import { Campaign } from '@app/shared/models/campaign';
import { DomainSettings } from '@app/shared/models/domainSettings';
import { GetRecordOutput } from '@smash-sdk/domain/01-2024';
import { environment } from './environments/environment';
export class Constant {
    public static resourceTagKeys = {
        applicationID: 'applicationID',
        version: 'version',
    };

    public static globalRegion = 'global';

    public static resourceTagValues = {
        applicationID: 'LambdastaticSmashApp',
    };
    public static smashQueryParams = {
        campaignId: 'campaign_id',
        campaignLanguage: 'campaign_language',
        campaignCountryCode: 'campaign_country_code',
    };
    public static encodedInfosRedirectionKey = 'infos';
    public static maxUploadSizeFreemium = 2000000000;
    public static oneDayInSecond = 86400;
    public static regexpDomainCreation = /^([a-z0-9-_]{1,62})$/;
    public static captchaKey = environment.captchaKey;
    public static accountTypes = {
        developer: 'developer',
        premium: 'premium',
    };
    public static previewOptions = [
        { value: 'Full', translation: 'UPLOADER_CONFIG_SMASH_PREVIEW_NOTIFICATION_ENABLED' },
        { value: 'None', translation: 'UPLOADER_CONFIG_SMASH_PREVIEW_NOTIFICATION_DISABLED' },
    ];
    public static notificationOptions = [
        { value: 'All', translation: 'UPLOADER_CONFIG_SMASH_PREVIEW_NOTIFICATION_ENABLED' },
        { value: 'None', translation: 'UPLOADER_CONFIG_SMASH_PREVIEW_NOTIFICATION_DISABLED' },
    ];
    public static regexpPromotionLink = /^(https?:\/\/.+)|(mailto:.+)$/;
    public static passwordPattern = '^.{4,}$';
    public static passwordStrengthRegexps = {
        strong: /^(?=(.*[0-9]))(?=.*[\!@#$%^&*()\\[\]{}\-_+=~`|:;"'<>,./?])(?=.*[a-z])(?=(.*[A-Z]))(?=(.*)).{8,}/,
        medium: /^(((?=.*[a-z])(?=.*[A-Z]))|((?=.*[a-z])(?=.*[0-9]))|((?=.*[a-z])(?=.*[\!@#$%^&*()\\[\]{}\-_+=~`|:;"'<>,./?]))|((?=.*[A-Z])(?=.*[0-9])))(?=.{6,})/,
    };
    public static VATRegexp = /^((AT)?U[0-9]{8}|(BE)?0[0-9]{9}|(BG)?[0-9]{9,10}|(CY)?[0-9]{8}L|(CZ)?[0-9]{8,10}|(DE)?[0-9]{9}|(DK)?[0-9]{8}|(EE)?[0-9]{9}|(EL|GR)?[0-9]{9}|(ES)?[0-9A-Z][0-9]{7}[0-9A-Z]|(FI)?[0-9]{8}|(FR)?[0-9A-Z]{2}[0-9]{9}|(GB)?([0-9]{9}([0-9]{3})?|[A-Z]{2}[0-9]{3})|(HU)?[0-9]{8}|(IE)?[0-9]S[0-9]{5}L|(IT)?[0-9]{11}|(LT)?([0-9]{9}|[0-9]{12})|(LU)?[0-9]{8}|(LV)?[0-9]{11}|(MT)?[0-9]{8}|(NL)?[0-9]{9}B[0-9]{2}|(PL)?[0-9]{10}|(PT)?[0-9]{9}|(RO)?[0-9]{2,10}|(SE)?[0-9]{12}|(SI)?[0-9]{8}|(SK)?[0-9]{10})$/;
    public static regexpCustomUrl = /^((?!(-[0-9a-zA-Z]{2}$))(?!([\#\)\(+\\\/]+)).)+$/;
    public static signupEmailPattern = /^[a-z0-9_.+-]+@[a-z0-9-]+\.[a-z0-9-.]+$/;
    public static regexpGroupName = /^[^,;]+$/;
    public static regexpYoutube = /^(?:(?:https?:)?\/\/)?(?:(?:www|m)\.)?(?:(?:youtube\.com|youtu.be))(?:\/(?:[\w-]+\?v=|embed\/|v\/)?)([\w-]+)(\S+)?$/;
    public static regexpVimeo = /^https?:\/\/(?:www\.|player\.)?vimeo.com\/(?:channels\/(?:\w+\/)?|groups\/(?:[^/]*)\/videos\/|album\/(?:\d+)\/video\/|video\/|)(\d+)(?:$|\/|\?)/;
    public static deliveryTypes = {
        Email: 'Email',
        Link: 'Link',
        Slack: 'Slack',
    };
    public static domainLoginRedirection = {
        None: 'None',
        Signin: 'RedirectToSignin',
        Provider: 'RedirectToProvider',
    };
    public static regexpExtractEmail = /([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/;
    public static regexpEmail = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z0-9]{2,20}$/;
    public static regexpDomainExtension = /\w+((\.[a-z]{2,5})(\.(ninja|rocks|com))?)$/;
    public static regexpExcludeUserSCIM = /^((?!\$scim).)*$/i;
    public static pricingUrls = {
        fr: 'https://fromsmash.com/fr/offres',
        en: 'https://fromsmash.com/pricing',
        es: 'https://fromsmash.com/es/precios',
        it: 'https://fromsmash.com/it/pricing',
        pt: 'https://fromsmash.com/pt/pricing',
        de: 'https://fromsmash.com/de/pricing',
        fallback: 'https://fromsmash.com/pricing',
    };
    public static subscriptionStatus = {
        Active: 'Active',
        Inactive: 'Inactive',
        Pending: 'Pending',
        PaymentRequired: 'Payment Required',
    };
    public static uploadStatus = {
        Queued: 'QUEUED',
        Starting: 'STARTING',
        Started: 'STARTED',
        Locked: 'LOCKED',
    };
    public static transferStatus = {
        Uploading: 'Uploading',
        Processing: 'Processing',
        Uploaded: 'Uploaded',
        Suspended: 'Suspended',
        Expired: 'Expired',
        Deleted: 'Deleted',
        Deleting: 'Deleting',
    };
    public static previewStatus = {
        None: 'None',
        Full: 'Full',
    };
    public static accessTracking = {
        None: 'None',
        Email: 'Email'
    };
    public static uploaderStep = {
        Landing: 'LANDING',
    };
    public static planGroupIdLength = 42;
    public static errorStatus = {
        uploader: {
            linkAlreadyExists: 'UPLOADER_LINK_ALREADY_EXISTS',
        },
    };
    public static providerPlayerTypes = {
        vimeo: 'Vimeo',
        youtube: 'Youtube',
        html5: 'html5',
    };
    public static administratorRoleName = 'ManagedAdministratorRole';
    public static SCIMRoleName = 'ManagedSCIMRole';
    public static marketerRoleName = 'Marketer';
    public static reporterRoleName = 'Reporter';
    public static urlYoutubeIframeAPI = 'https://www.youtube.com/iframe_api';
    public static urlVimeoIframeAPI = 'https://player.vimeo.com/api/player.js';
    public static previewableExtensions = ['.jpg', '.jpeg', '.png', '.mp3', '.avi', '.wav', '.mp4', '.mov', '.m4v'];
    public static callToActionsList = [
        { value: 'Buy', translation: 'PREMIUM_PROMOTION_OPTION_CALL_TO_ACTION_BUY' },
        { value: 'Discover', translation: 'PREMIUM_PROMOTION_OPTION_CALL_TO_ACTION_DISCOVER' },
        { value: 'Order', translation: 'PREMIUM_PROMOTION_OPTION_CALL_TO_ACTION_ORDER' },
        { value: 'Signup', translation: 'PREMIUM_PROMOTION_OPTION_CALL_TO_ACTION_REGISTER' },
        { value: 'Subscribe', translation: 'PREMIUM_PROMOTION_OPTION_CALL_TO_ACTION_SUBSCRIBE' },
        { value: 'Contact', translation: 'PREMIUM_PROMOTION_OPTION_CALL_TO_ACTION_CONTACT_US' },
        { value: 'Download', translation: 'PREMIUM_PROMOTION_OPTION_CALL_TO_ACTION_DOWNLOAD' },
        { value: 'Share', translation: 'PREMIUM_PROMOTION_OPTION_CALL_TO_ACTION_SHARE' },
        { value: 'Like', translation: 'PREMIUM_PROMOTION_OPTION_CALL_TO_ACTION_I_LIKE' },
        { value: 'Test', translation: 'PREMIUM_PROMOTION_OPTION_CALL_TO_ACTION_TRY' },
        { value: 'JoinIn', translation: 'PREMIUM_PROMOTION_OPTION_CALL_TO_ACTION_JOIN_IN' },
        { value: 'Play', translation: 'PREMIUM_PROMOTION_OPTION_CALL_TO_ACTION_PLAY' },
        { value: 'AddToPlaylist', translation: 'PREMIUM_PROMOTION_OPTION_CALL_TO_ACTION_ADD_TO_PLAYLIST' },
        { value: 'FollowUs', translation: 'PREMIUM_PROMOTION_OPTION_CALL_TO_ACTION_FOLLOW_US' },
        { value: 'DiscoverSmash', translation: 'PREMIUM_PROMOTION_OPTION_CALL_TO_ACTION_DISCOVER_SMASH' },
        { value: 'Read', translation: 'PREMIUM_PROMOTION_OPTION_CALL_TO_ACTION_READ' },
        { value: 'Watch', translation: 'PREMIUM_PROMOTION_OPTION_CALL_TO_ACTION_WATCH' },
        { value: 'LearnMore', translation: 'PREMIUM_PROMOTION_OPTION_CALL_TO_ACTION_KNOW_MORE' },
        { value: 'Book', translation: 'PREMIUM_PROMOTION_OPTION_CALL_TO_ACTION_BOOK' },
        { value: 'Act', translation: 'PREMIUM_PROMOTION_OPTION_CALL_TO_ACTION_ACT' },
    ];
    public static refreshTokenStatus = {
        Processing: 'Processing',
        Success: 'Success',
        Failure: 'Failure',
    };
    public static Unknown = 'Unknown';
    public static Currencies = {
        Eur: 'eur',
        Usd: 'usd',
    };
    public static teamConfig = {
        authenticationMode: {
            anonymous: 'Anonymous',
            authentified: 'Authentified',
        },
        rulesNames: {
            wildcard: 'Wildcard',
            email: 'Email'
        }
    };
    public static planFreemiumID = 'SMASH_FREEMIUM';
    public static authenticationPatternEmailWithAt = /^@[a-z0-9-]+\.[a-z0-9-]+\.*[a-z0-9-]*$/;
    public static authenticationPatternEmail = /^[a-z0-9-]+\.[a-z0-9-]+\.*[a-z0-9-]*$/;
    public static authenticationMode = {
        anonymous: 'Anonymous',
        authentified: 'Authentified',
    };
    public static fileTypes = {
        Image: 'image',
        Video: 'Video',
        Document: 'Document',
    };
    public static countryCodes = {
        FR: 'FR',
    };
    public static countryCodesVAT = ['FR', 'GP', 'MC', 'RE', 'MQ'];

    public static paymentType = {
        CARD: 'card',
        PAYPAL: 'paypal',
    };
    public static paymentStatus = {
        SUCCESS: 'Success',
        FAILURE: 'Failure',
    };
    // FIX ME in use?
    public static delayScale = [
        {
            minSize: 0, // 0
            maxSize: 2000000000, // 2G
            delayPerGo: 0,
            minDelay: 0,
        },
        {
            minSize: 2000000001, // 2G
            maxSize: 5000000000, // 5G
            delayPerGo: 3600, // 60min par G
            minDelay: 3600 * 21, // 21 heures
        },
        {
            minSize: 5000000001, // 5G
            maxSize: 10000000000, // 10G
            delayPerGo: 3600, // 60min par G
            minDelay: 3600 * 24, // 24 heures => 29 heaures
        },
        {
            minSize: 10000000001, // 10G
            maxSize: 20000000000, // 20G
            delayPerGo: 3600, // 60min par G
            minDelay: 3600 * 29, // 29 heures => 39 heures
        },
        {
            minSize: 20000000001, // 20G
            maxSize: 50000000000, // 50G
            delayPerGo: 0, // 0min par G
            minDelay: 3600 * 24 * 2, // 2 jours
        },
        {
            minSize: 50000000001, // 50G
            maxSize: 100000000000, // 100G
            delayPerGo: 0, // 0min par G
            minDelay: 3600 * 24 * 3, // 3 jours
        },
        {
            minSize: 100000000001, // 100G
            maxSize: Infinity,
            delayPerGo: 0, // 0min par G
            minDelay: 3600 * 24 * 7, // 7 jours
        },
    ];
    public static supportedLanguages = [
        {
            id: 'fr',
            name: 'Français'
        },
        {
            id: 'de',
            name: 'Deutsch'
        },
        {
            id: 'en',
            name: 'English'
        },
        {
            id: 'es',
            name: 'Español'
        },
        {
            id: 'it',
            name: 'Italiano'
        },
        {
            id: 'pt',
            name: 'Português'
        }
    ];
    public static transferEventStatus = {
        view: 'View',
        download: 'Download',
    };
    public static transferEventResource = {
        file: 'File',
        transfer: 'Transfer',
    };
    public static uploaderErrorType = {
        emailForbidden: 'EmailNotAllowedError',
        invalidSubscription: 'InvalidSubscriptionError',
        invalidAvailabilityDurationError: 'InvalidAvailabilityDurationError',
        passwordRequired: 'PasswordRequiredError',
        customUrlAlreadyInUse: 'CustomUrlAlreadyInUseError',
    };
    public static userStatus = {
        enabled: 'Enabled',
        disabled: 'Disabled',
    };
    public static ssoProviderStatus = {
        enabled: 'Enabled',
        disabled: 'Disabled',
    };
    // FIX ME in use?
    public static targetCountryAds = ['GB', 'US', 'CA', 'AU', 'SG', 'PH', 'IN', 'BR', 'MX', 'CO', 'AR', 'PE', 'CL', 'EC', 'BO'];
    public static customizationFallback = {
        logo: {
            waveColor: '#EA5159',
            sourceUrl: 'https://fromsmash.com/assets/img/smash-logo/png/icono-chip-full-white.png',
            thumnail: 'https://fromsmash.com/assets/img/smash-logo/png/icono-chip-full-white.png',
            type: 'Image'
        },
        background: {
            sourceUrl: 'https://asset.fromsmash.co/media/email/background_red', // TODO change to black
            type: 'Image'
        },
    };

    // FIX ME in use?
    public static REGIONS = {
        'eu-west-3': 'FR',
        'eu-west-2': 'GB',
        'eu-west-1': 'IE',
        'eu-central-1': 'DE',
        'ca-central-1': 'CA',
        'us-east-1': 'US',
        'us-east-2': 'US',
        'us-west-1': 'US',
        'us-west-2': 'US',
    };

    public static europeanRegions = ['eu-west-1', 'eu-west-2', 'eu-west-3', 'eu-central-1'];

    public static SsoParams = {
        types: {
            SAML: 'Saml'
        },
        name: 'primarySsoParams',
    };

    public static signinMode = {
        standard: 'Standard',
        sso: 'SSO',
    };

    public static domainType = {
        CNAME: 'CName'
    };

    public static SAMLRequestKey = 'SAMLRequest';

    public static transferMode = {
        dropbox: 'Dropbox',
        transfer: 'Transfer',
    };

    public static defaultManagedDomainSettings: DomainSettings = {
        transferMode: {
            active: true,
            default: 'Transfer',
            options: ['Transfer'],
        },
        transfer: {
            availabilityDuration: {
                active: true,
                default: 7,
                min: 1,
                max: 14
            },
            preview: {
                options: [
                    Constant.previewStatus.Full,
                    Constant.previewStatus.None,
                ],
                active: true,
                default: Constant.previewStatus.Full,
            },
            delivery: {
                options: [
                    Constant.deliveryTypes.Email,
                    Constant.deliveryTypes.Link,
                ],
                active: true,
                default: Constant.deliveryTypes.Email,
            },
            password: {
                active: true,
                minLength: 4,
                required: false,
            },
            customization: {
                active: true
            },
            notification: {
                sender: { active: true, enabled: true },
                link: { active: true, enabled: true },
                receiver: { active: true, enabled: true },
                download: { active: true, enabled: true },
                noDownload: { active: true, enabled: true },

            },
            accessTracking: {
                active: true,
                default: 'None',
            },
            promotion: {
                active: true
            }
        },
        redirection: {
            active: true,
            value: Constant.domainLoginRedirection.None,
            options: [
                Constant.domainLoginRedirection.None,
                Constant.domainLoginRedirection.Signin,
                Constant.domainLoginRedirection.Provider,
            ]
        }
    };

    public static defaultPremiumDomainSettings: GetRecordOutput['record']['options'] = {
        transferMode: {
            active: true,
            default: 'Transfer',
            options: ['Dropbox', 'Transfer'],
        },
        transfer: {
            availabilityDuration: {
                active: true,
                default: 7,
                max: 30,
                min: 1,
            },
            preview: {
                active: true,
                default: 'Full',
                options: [
                    'None',
                    'Full',
                ]
            },
            delivery: {
                active: true,
                default: 'Email',
                options: [
                    'Link',
                    'Email',
                ]
            },
            password: {
                active: true,
                required: false,
                minLength: 4
            },
            customization: {
                active: true,
            },
            notification: {
                sender: { active: true, enabled: true },
                link: { active: true, enabled: true },
                receiver: { active: true, enabled: true },
                download: { active: true, enabled: true },
                noDownload: { active: true, enabled: true },
            },
            accessTracking: {
                active: false,
                default: 'None',
            },
            promotion: {
                active: true,
            },
        },
        dropbox: {
            maxTransferCount: {
                active: true,
                default: undefined,
                min: 1,
            },
            availabilityDuration: {
                active: true,
                default: 7 * 86400,
                max: 365 * 86400,
                min: 86400,
            },
            maxBytesUploaded: {
                active: true,
                default: undefined,
                max: undefined,
                min: 1,
            },
            transfer: {
                notification: {
                    sender: { active: true, enabled: true },
                    receiver: { active: true, enabled: true },
                    download: { active: true, enabled: true },
                    noDownload: { active: true, enabled: true },
                },
                preview: {
                    active: true,
                    default: 'Full',
                    options: [
                        'None',
                        'Full',
                    ]
                },
                password: {
                    active: true,
                    required: false,
                    minLength: 4
                },
                availabilityDuration: {
                    active: true,
                    default: 7 * 86400,
                    max: 30 * 86400,
                    min: 86400,
                },
            }
        },
        redirection: {
            active: true,
            value: 'None',
            options: [
                'RedirectToProvider',
                'RedirectToSignin',
                'None',
            ]
        }
    };

    public static osType = {
        iOS: 'iOS',
        android: 'Android',
    };

    // NOT USED
    public static squareSpaceUrls = {
        apps: {
            en: 'https://en.fromsmash.com/smash-app',
            fr: 'https://fr.fromsmash.com/apps-mobile',
            es: 'https://es.fromsmash.com/aplicaciones-moviles',
            de: 'https://en.fromsmash.com/smash-app',
            it: 'https://en.fromsmash.com/smash-app',
            pt: 'https://en.fromsmash.com/smash-app',
            default: 'https://en.fromsmash.com/smash-app',
        },
        mobile: {
            en: 'https://en.fromsmash.com',
            fr: 'https://fr.fromsmash.com',
            es: 'https://en.fromsmash.com',
            de: 'https://en.fromsmash.com',
            it: 'https://en.fromsmash.com',
            pt: 'https://en.fromsmash.com',
            default: 'https://en.fromsmash.com',
        }
    };

    public static eventGTM = {
        SUBSCRIPTION: 'subscription',
        UPDATE_SUBSCRIPTION: 'update_subscription',
        START_TRANSFER: 'start_transfer',
        TRANSFER_INITIATED: 'transfer_initiated',
        TRANSFER_CANCELLED: 'transfer_cancelled',
        TRANSFER_LOCKED: 'transfer_locked',
        SMASH_AGAIN: 'smash_again',
        SIGNIN: 'signin',
        EXTERNAL_PROMOTION_DISPLAYED: 'external_promotion_displayed',
        INTERNAL_PROMOTION_DISPLAYED: 'internal_promotion_displayed',
        CLICK_PROMOTION_CTA: 'click_promotion_cta',
        CLICK_ADD_PROMOTION_FREEMIUM: 'click_add_promotion_freemium',
        CLICK_ADD_BACKGROUND_LOGO_FREEMIUM: 'click_add_background_logo_freemium',
        CLICK_BACKDROP_MODAL_SIZE_PREMIUM: 'click_backdrop_modal_size_premium',
        CLICK_REDIRECTION_CAMPAIGN: 'click_campaign_link',
        VIEW_VIDEO_COMPLETION: 'view_video_completion',
    };

    public static languageFallback = 'en';

    public static domainRegexp = /(?:https?:\/\/)?(?:www\.)?(?:[[0-9A-Za-z\-]+\.)?([[0-9A-Za-z\-]+\.[[0-9A-Za-z\-\.]+)/;
    public static httpUrlRegexp = /https:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{1,}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/;

    // TO REMOVE
    public static campaigns: { [key: string]: Campaign[] } = {
        FR: [
            // ZERO TO ONE
            // Access url = https://fromsmash.com/?campaign_id=zerotoone_1&campaign_language=fr&campaign_country_code=FR
            {
                name: 'zerotoone_1',
                language: 'DEFAULT',
                target: 'All',
                status: 'Enabled',
                customization: {
                    background: {
                        type: 'Image',
                        sourceUrl: 'assets/campaigns/zerotoone/teaser.png',
                        id: 'campaign_zerotoone_customization_background_desktop_1'
                    },
                    logo: {
                        thumbnail: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                        sourceUrl: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                    },
                    header: {
                        logo: 'assets/campaigns/zerotoone/logo.png',
                        text: 'Une journée de conférences pour monter en compétences et vous inspirer des parcours des talents des plus belles start-up.',
                        link: 'https://0-2-1.eu/trouvez-vos-clients/',
                        logoPaddingBottom: '0.7rem',
                        logoPaddingLeft: '2.5rem',
                        mainLogoCollabContainerHeight: '5rem',
                        // logoCollabContainerHeight: '9.2rem',
                        translateOffset: 'translateX(-28rem)',
                    },
                },
                promotions: [
                    {
                        language: 'default',
                        teaserDisabled: true,
                        text: 'Le 13 juin, zero to one, l’événement start-up dédié à la tech, l’impact et la créativité organisé par H7 revient pour une 3e édition à Lyon !',
                        link: 'https://0-2-1.eu/trouvez-vos-clients/',
                        target: 'All',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'ZERO_TO_ONE_1_PROMOTION_DESKTOP_INTERNAL',
                        title: 'ZERO_TO_ONE_1',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/zerotoone/S_reveal01.png',
                                type: 'Image'
                            },
                        ]
                    }
                ]
            },
            // Access url = https://fromsmash.com/?campaign_id=zerotoone_2&campaign_language=fr&campaign_country_code=FR
            {
                name: 'zerotoone_2',
                language: 'DEFAULT',
                target: 'All',
                status: 'Enabled',
                customization: {
                    background: {
                        type: 'Image',
                        sourceUrl: 'assets/campaigns/zerotoone/teaser.png',
                        id: 'campaign_zerotoone_customization_background_desktop_1'
                    },
                    logo: {
                        thumbnail: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                        sourceUrl: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                    },
                    header: {
                        logo: 'assets/campaigns/zerotoone/logo.png',
                        text: 'Une journée de conférences pour monter en compétences et vous inspirer des parcours des talents des plus belles start-up.',
                        link: 'https://0-2-1.eu/financez-votre-croissance/',
                        logoPaddingBottom: '0.7rem',
                        logoPaddingLeft: '2.5rem',
                        mainLogoCollabContainerHeight: '5rem',
                        // logoCollabContainerHeight: '9.2rem',
                        translateOffset: 'translateX(-28rem)',
                    },
                },
                promotions: [
                    {
                        language: 'default',
                        teaserDisabled: true,
                        text: 'Le 13 juin, zero to one, l’événement start-up dédié à la tech, l’impact et la créativité organisé par H7 revient pour une 3e édition à Lyon !',
                        link: 'https://0-2-1.eu/financez-votre-croissance/',
                        target: 'All',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'ZERO_TO_ONE_2_PROMOTION_DESKTOP_INTERNAL',
                        title: 'ZERO_TO_ONE_2',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/zerotoone/S_reveal02.png',
                                type: 'Image'
                            },
                        ]
                    }
                ]
            },
            // Access url = https://fromsmash.com/?campaign_id=zerotoone_3&campaign_language=fr&campaign_country_code=FR
            {
                name: 'zerotoone_3',
                language: 'DEFAULT',
                target: 'All',
                status: 'Enabled',
                customization: {
                    background: {
                        type: 'Image',
                        sourceUrl: 'assets/campaigns/zerotoone/teaser.png',
                        id: 'campaign_zerotoone_customization_background_desktop_1'
                    },
                    logo: {
                        thumbnail: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                        sourceUrl: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                    },
                    header: {
                        logo: 'assets/campaigns/zerotoone/logo.png',
                        text: 'Une journée de conférences pour monter en compétences et vous inspirer des parcours des talents des plus belles start-up.',
                        link: 'https://0-2-1.eu/enchantez-vos-utilisateurs/',
                        logoPaddingBottom: '0.7rem',
                        logoPaddingLeft: '2.5rem',
                        mainLogoCollabContainerHeight: '5rem',
                        // logoCollabContainerHeight: '9.2rem',
                        translateOffset: 'translateX(-28rem)',
                    },
                },
                promotions: [
                    {
                        language: 'default',
                        teaserDisabled: true,
                        text: 'Le 13 juin, zero to one, l’événement start-up dédié à la tech, l’impact et la créativité organisé par H7 revient pour une 3e édition à Lyon !',
                        link: 'https://0-2-1.eu/enchantez-vos-utilisateurs/',
                        target: 'All',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'ZERO_TO_ONE_3_PROMOTION_DESKTOP_INTERNAL',
                        title: 'JZERO_TO_ONE_3',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/zerotoone/S_reveal03.png',
                                type: 'Image'
                            },
                        ]
                    }
                ]
            },

            // Access url = https://fromsmash.com/?campaign_id=jazzajuan&campaign_language=fr&campaign_country_code=FR
            {
                name: 'jazzajuan',
                language: 'DEFAULT',
                target: 'All',
                status: 'Enabled',
                customization: {
                    background: {
                        type: 'Vimeo',
                        sourceId: 'https://vimeo.com/946489368',
                        id: 'campaign_jazz_a_juan_customization_background_desktop_1'
                    },
                    logo: {
                        thumbnail: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                        sourceUrl: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                    },
                    header: {
                        logo: 'assets/campaigns/jazzajuan/logo.png',
                        text: 'Depuis 1960, le festival Jazz à Juan accueille les plus grands noms du Jazz',
                        link: 'https://jazzajuan.com/',
                        logoPaddingBottom: '0.7rem',
                        logoPaddingLeft: '2.5rem',
                        mainLogoCollabContainerHeight: '8.5rem',
                        logoCollabContainerHeight: '9.2rem',
                        translateOffset: 'translateX(-28rem)',
                    },
                },
                promotions: [
                    {
                        language: 'default',
                        teaserDisabled: true,
                        text: 'Depuis 1960, le festival Jazz à Juan accueille les plus grands noms du Jazz. Dans un cadre exceptionnel, découvrez la programmation de l’un des festivals de jazz les plus prestigieux du monde.',
                        link: 'https://jazzajuan.com/',
                        target: 'All',
                        status: 'Enabled',
                        button: 'LearnMore',
                        id: 'JAZZ_A_JUAN_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Jazz à Juan',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/jazzajuan/reveal_fr_1.jpg',
                                type: 'Image'
                            },
                        ]
                    }
                ]
            },
            // Access url = https://fromsmash.com/?campaign_id=jazzajuan&campaign_language=fr&campaign_country_code=FR
            {
                name: 'jazzajuan',
                language: 'DEFAULT',
                target: 'All',
                status: 'Enabled',
                customization: {
                    background: {
                        type: 'Vimeo',
                        sourceId: 'https://vimeo.com/946489368',
                        id: 'campaign_jazz_a_juan_customization_background_desktop_1'
                    },
                    logo: {
                        thumbnail: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                        sourceUrl: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                    },
                    header: {
                        logo: 'assets/campaigns/jazzajuan/logo.png',
                        text: 'Depuis 1960, le festival Jazz à Juan accueille les plus grands noms du Jazz',
                        link: 'https://jazzajuan.com/',
                        logoPaddingBottom: '0.7rem',
                        logoPaddingLeft: '2.5rem',
                        mainLogoCollabContainerHeight: '8.5rem',
                        logoCollabContainerHeight: '9.2rem',
                        translateOffset: 'translateX(-28rem)',
                    },
                },
                promotions: [
                    {
                        language: 'default',
                        teaserDisabled: true,
                        text: 'Depuis 1960, le festival Jazz à Juan accueille les plus grands noms du Jazz. Dans un cadre exceptionnel, découvrez la programmation de l’un des festivals de jazz les plus prestigieux du monde.',
                        link: 'https://jazzajuan.com/',
                        target: 'All',
                        status: 'Enabled',
                        button: 'LearnMore',
                        id: 'JAZZ_A_JUAN_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Jazz à Juan',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/jazzajuan/reveal_fr_1.jpg',
                                type: 'Image'
                            },
                        ]
                    }
                ]
            },
            // Access url = https://fromsmash.com/?campaign_id=jazzajuan&campaign_language=fr&campaign_country_code=FR
            {
                name: 'jazzajuan',
                language: 'DEFAULT',
                target: 'All',
                status: 'Enabled',
                customization: {
                    background: {
                        type: 'Vimeo',
                        sourceId: 'https://vimeo.com/946489368',
                        id: 'campaign_jazz_a_juan_customization_background_desktop_1'
                    },
                    logo: {
                        thumbnail: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                        sourceUrl: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                    },
                    header: {
                        logo: 'assets/campaigns/jazzajuan/logo.png',
                        text: 'Depuis 1960, le festival Jazz à Juan accueille les plus grands noms du Jazz',
                        link: 'https://jazzajuan.com/',
                        logoPaddingBottom: '0.7rem',
                        logoPaddingLeft: '2.5rem',
                        mainLogoCollabContainerHeight: '8.5rem',
                        logoCollabContainerHeight: '9.2rem',
                        translateOffset: 'translateX(-28rem)',
                    },
                },
                promotions: [
                    {
                        language: 'default',
                        teaserDisabled: true,
                        text: 'Depuis 1960, le festival Jazz à Juan accueille les plus grands noms du Jazz. Dans un cadre exceptionnel, découvrez la programmation de l’un des festivals de jazz les plus prestigieux du monde.',
                        link: 'https://jazzajuan.com/',
                        target: 'All',
                        status: 'Enabled',
                        button: 'LearnMore',
                        id: 'JAZZ_A_JUAN_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Jazz à Juan',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/jazzajuan/reveal_fr_1.jpg',
                                type: 'Image'
                            },
                        ]
                    }
                ]
            },
        ],
        BE: [
            // Royal Bliss
            {
                name: 'Royal Bliss',
                language: 'DEFAULT',
                target: 'All',
                customization: {
                    header: {
                        logo: 'assets/campaigns/royalbliss/teasing/logo.png',
                        text: 'Niet zomaar je alledaagse tonic.',
                        link: 'https://ad.doubleclick.net/ddm/trackclk/N448205.5141287SMASH/B31643274.389550521;dc_trk_aid=581007834;dc_trk_cid=211137640;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;ltd=;dc_tdv=1',
                        logoPaddingBottom: '0.7rem',
                        logoPaddingLeft: '2.5rem',
                        mainLogoCollabContainerHeight: '8.5rem',
                        logoCollabContainerHeight: '9.2rem',
                        translateOffset: 'translateX(-28rem)',
                    },
                    background: {
                        type: 'Iframe',
                        sourceUrl: 'assets/campaigns/royalbliss/teasing/campaign_royal_bliss_nl_customization_background_desktop.html',
                        id: 'royal_bliss_nl_customization_background_desktop'
                    },
                    logo: {
                        thumbnail: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                        sourceUrl: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                    }
                },
                promotions: [
                    {
                        language: 'en',
                        teaserDisabled: true,
                        text: 'Geniet van Royal Bliss Tonic Water met een unieke botanische twist. Drink \'m puur of gemixt!',
                        link: 'https://ad.doubleclick.net/ddm/trackclk/N448205.5141287SMASH/B31643274.389550521;dc_trk_aid=581007834;dc_trk_cid=211137640;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;ltd=;dc_tdv=1',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'ROYAL_BLISS_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Royal Bliss',
                        medias: [
                            {
                                sourceId: 'https://youtu.be/Qu8xO4_slq8',
                                type: 'Youtube'
                            },
                        ]
                    },
                    {
                        language: 'en',
                        teaserDisabled: true,
                        text: 'Geniet van Royal Bliss Tonic Water met een unieke botanische twist. Drink \'m puur of gemixt!',
                        link: 'https://ad.doubleclick.net/ddm/trackclk/N448205.5141287SMASH/B31643274.389550521;dc_trk_aid=581007834;dc_trk_cid=211137640;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;ltd=;dc_tdv=1',
                        target: 'External',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'ROYAL_BLISS_PROMOTION_DESKTOP_EXTERNAL',
                        title: 'Royal Bliss',
                        medias: [
                            {
                                sourceId: 'https://youtu.be/Qu8xO4_slq8',
                                type: 'Youtube'
                            },
                        ]
                    }
                ]
            },
            {
                name: 'Royal Bliss',
                language: 'FR',
                target: 'All',
                customization: {
                    header: {
                        logo: 'assets/campaigns/royalbliss/teasing/logo.png',
                        text: 'Bien plus que votre tonic ordinaire.',
                        link: 'https://ad.doubleclick.net/ddm/trackclk/N448205.5141287SMASH/B31643274.389552564;dc_trk_aid=581010075;dc_trk_cid=211137640;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;ltd=;dc_tdv=1',
                        logoPaddingBottom: '0.7rem',
                        logoPaddingLeft: '2.5rem',
                        mainLogoCollabContainerHeight: '8.5rem',
                        logoCollabContainerHeight: '9.2rem',
                        translateOffset: 'translateX(-28rem)',
                    },
                    background: {
                        type: 'Iframe',
                        sourceUrl: 'assets/campaigns/royalbliss/teasing/campaign_royal_bliss_fr_customization_background_desktop.html',
                        id: 'royal_bliss_fr_customization_background_desktop'
                    },
                    logo: {
                        thumbnail: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                        sourceUrl: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                    }
                },
                promotions: [
                    {
                        language: 'fr',
                        teaserDisabled: true,
                        text: 'Savoure Royal Bliss Tonic Water avec ses nuances botaniques unique. Goûte-le pur ou mixé !',
                        link: 'https://ad.doubleclick.net/ddm/trackclk/N448205.5141287SMASH/B31643274.389552564;dc_trk_aid=581010075;dc_trk_cid=211137640;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;ltd=;dc_tdv=1',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'ROYAL_BLISS_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Royal Bliss',
                        medias: [
                            {
                                sourceId: 'https://youtu.be/ltTLKFUykSg',
                                type: 'Youtube'
                            },
                        ]
                    },
                    {
                        language: 'fr',
                        teaserDisabled: true,
                        text: 'Savoure Royal Bliss Tonic Water avec ses nuances botaniques unique. Goûte-le pur ou mixé !',
                        link: 'https://ad.doubleclick.net/ddm/trackclk/N448205.5141287SMASH/B31643274.389552564;dc_trk_aid=581010075;dc_trk_cid=211137640;dc_lat=;dc_rdid=;tag_for_child_directed_treatment=;tfua=;ltd=;dc_tdv=1',
                        target: 'External',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'ROYAL_BLISS_PROMOTION_DESKTOP_EXTERNAL',
                        title: 'Royal Bliss',
                        medias: [
                            {
                                sourceId: 'https://youtu.be/ltTLKFUykSg',
                                type: 'Youtube'
                            },
                        ]
                    },
                ]
            },
        ],
        IN: [
            // SOPRA_STERIA
            {
                name: 'SOPRA_STERIA',
                language: 'DEFAULT',
                target: 'All',
                customization: {
                    header: {
                        logo: 'assets/campaigns/sopra_steria/logo.png',
                        text: 'Sopra Steria - Free in my job',
                        link: 'https://careers.smartrecruiters.com/SopraSteria1/soprasteria-in',
                        translateOffset: 'translateX(-32rem)',
                        logoPaddingLeft: '2.5rem',
                        mainLogoCollabContainerHeight: '5rem',
                    },
                    background: {
                        type: 'Image',
                        sourceUrl: 'assets/campaigns/sopra_steria/teaser.jpg',
                        id: 'sopra_steria_customization_background_desktop'
                    },
                    logo: {
                        thumbnail: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                        sourceUrl: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                    }
                },
                promotions: [
                    {
                        language: 'en',
                        teaserDisabled: true,
                        text: 'Join Sopra Steria, a place where you are free to unleash your creativity and take initiatives, while being supported by tech experts!',
                        link: 'https://careers.smartrecruiters.com/SopraSteria1/soprasteria-in',
                        target: 'All',
                        status: 'Enabled',
                        button: 'LearnMore',
                        id: 'SOPRA_STERIA_PROMOTION_DESKTOP_ALL',
                        title: 'SOPRA_STERIA',
                        medias: [
                            {
                                sourceId: 'https://www.youtube.com/watch?v=cRWYvgFeWhA&ab_channel=SopraSteria',
                                type: 'Youtube',
                            },
                        ]
                    },
                ]

            },
        ],
        ES: [
            // Crazy Days
            {
                name: 'Offre spéciale 1',
                language: 'DEFAULT',
                target: 'All',
                customization: {
                    background: {
                        type: 'Image',
                        sourceUrl: 'assets/campaigns/smash/crazydays/Smash_Teasing_01.png',
                        id: 'campaign_offre_customization_background_desktop'
                    },
                    logo: {
                        thumbnail: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                        sourceUrl: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                    }
                },
                promotions: [
                    {
                        language: 'fr',
                        teaserDisabled: true,
                        text: 'Découvrez dès maintenant l\'offre spéciale. Offre à durée limitée.',
                        link: 'https://fromsmash.com/fr/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/FR.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'en',
                        teaserDisabled: true,
                        text: 'Discover the limited-time offer now.',
                        link: 'https://fromsmash.com/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/EN.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'es',
                        teaserDisabled: true,
                        text: 'Descubra ahora la oferta por tiempo limitado.',
                        link: 'https://fromsmash.com/es/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/ES.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'de',
                        teaserDisabled: true,
                        text: 'Entdecken Sie jetzt das zeitlich begrenzte Angebot.',
                        link: 'https://fromsmash.com/de/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/DE.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'it',
                        teaserDisabled: true,
                        text: 'Scoprite subito l\'offerta a tempo limitato.',
                        link: 'https://fromsmash.com/it/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/IT.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'pt',
                        teaserDisabled: true,
                        text: 'Descubra agora a oferta de tempo limitado.',
                        link: 'https://fromsmash.com/pt/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/PT.png',
                                type: 'Image'
                            },
                        ]
                    }
                ]
            },
            {
                name: 'Offre spéciale 2',
                language: 'DEFAULT',
                target: 'All',
                customization: {
                    background: {
                        type: 'Image',
                        sourceUrl: 'assets/campaigns/smash/crazydays/Smash_Teasing_02.png',
                        id: 'campaign_offre_customization_background_desktop'
                    },
                    logo: {
                        thumbnail: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                        sourceUrl: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                    }
                },
                promotions: [
                    {
                        language: 'fr',
                        teaserDisabled: true,
                        text: 'Découvrez dès maintenant l\'offre spéciale. Offre à durée limitée.',
                        link: 'https://fromsmash.com/fr/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/FR.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'en',
                        teaserDisabled: true,
                        text: 'Discover the limited-time offer now.',
                        link: 'https://fromsmash.com/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/EN.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'es',
                        teaserDisabled: true,
                        text: 'Descubra ahora la oferta por tiempo limitado.',
                        link: 'https://fromsmash.com/es/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/ES.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'de',
                        teaserDisabled: true,
                        text: 'Entdecken Sie jetzt das zeitlich begrenzte Angebot.',
                        link: 'https://fromsmash.com/de/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/DE.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'it',
                        teaserDisabled: true,
                        text: 'Scoprite subito l\'offerta a tempo limitato.',
                        link: 'https://fromsmash.com/it/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/IT.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'pt',
                        teaserDisabled: true,
                        text: 'Descubra agora a oferta de tempo limitado.',
                        link: 'https://fromsmash.com/pt/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/PT.png',
                                type: 'Image'
                            },
                        ]
                    }
                ]
            },
            {
                name: 'Offre spéciale 3',
                language: 'DEFAULT',
                target: 'All',
                customization: {
                    background: {
                        type: 'Image',
                        sourceUrl: 'assets/campaigns/smash/crazydays/Smash_Teasing_03.png',
                        id: 'campaign_offre_customization_background_desktop'
                    },
                    logo: {
                        thumbnail: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                        sourceUrl: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                    }
                },
                promotions: [
                    {
                        language: 'fr',
                        teaserDisabled: true,
                        text: 'Découvrez dès maintenant l\'offre spéciale. Offre à durée limitée.',
                        link: 'https://fromsmash.com/fr/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/FR.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'en',
                        teaserDisabled: true,
                        text: 'Discover the limited-time offer now.',
                        link: 'https://fromsmash.com/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/EN.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'es',
                        teaserDisabled: true,
                        text: 'Descubra ahora la oferta por tiempo limitado.',
                        link: 'https://fromsmash.com/es/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/ES.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'de',
                        teaserDisabled: true,
                        text: 'Entdecken Sie jetzt das zeitlich begrenzte Angebot.',
                        link: 'https://fromsmash.com/de/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/DE.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'it',
                        teaserDisabled: true,
                        text: 'Scoprite subito l\'offerta a tempo limitato.',
                        link: 'https://fromsmash.com/it/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/IT.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'pt',
                        teaserDisabled: true,
                        text: 'Descubra agora a oferta de tempo limitado.',
                        link: 'https://fromsmash.com/pt/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/PT.png',
                                type: 'Image'
                            },
                        ]
                    }
                ]
            },
            {
                name: 'Offre spéciale 4',
                language: 'DEFAULT',
                target: 'All',
                customization: {
                    background: {
                        type: 'Image',
                        sourceUrl: 'assets/campaigns/smash/crazydays/Smash_Teasing_04.png',
                        id: 'campaign_offre_customization_background_desktop'
                    },
                    logo: {
                        thumbnail: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                        sourceUrl: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                    }
                },
                promotions: [
                    {
                        language: 'fr',
                        teaserDisabled: true,
                        text: 'Découvrez dès maintenant l\'offre spéciale. Offre à durée limitée.',
                        link: 'https://fromsmash.com/fr/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/FR.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'en',
                        teaserDisabled: true,
                        text: 'Discover the limited-time offer now.',
                        link: 'https://fromsmash.com/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/EN.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'es',
                        teaserDisabled: true,
                        text: 'Descubra ahora la oferta por tiempo limitado.',
                        link: 'https://fromsmash.com/es/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/ES.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'de',
                        teaserDisabled: true,
                        text: 'Entdecken Sie jetzt das zeitlich begrenzte Angebot.',
                        link: 'https://fromsmash.com/de/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/DE.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'it',
                        teaserDisabled: true,
                        text: 'Scoprite subito l\'offerta a tempo limitato.',
                        link: 'https://fromsmash.com/it/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/IT.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'pt',
                        teaserDisabled: true,
                        text: 'Descubra agora a oferta de tempo limitado.',
                        link: 'https://fromsmash.com/pt/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/PT.png',
                                type: 'Image'
                            },
                        ]
                    }
                ]
            },

            // Vote Anyway
            {
                name: 'Vote anyway',
                language: 'DEFAULT',
                target: 'All',
                customization: {
                    background: {
                        type: 'Image',
                        sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_teasing_01.jpg',
                        id: 'campaign_customization_background_vote_anyway_teasing_01'
                    },
                    logo: {
                        thumbnail: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                        sourceUrl: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                    }
                },
                promotions: [
                    {
                        language: 'en',
                        teaserDisabled: true,
                        text: 'Vote anyway! Between June 6 and 9, 2024, European citizens are called to the polls. #VoteAnyway',
                        link: 'https://www.vote-anyway.org/',
                        target: 'All',
                        status: 'Enabled',
                        button: 'LearnMore',
                        id: 'VOTE_ANYWAY_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Vote anyway',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_reveal_01.jpg',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'fr',
                        teaserDisabled: true,
                        text: 'Vote anyway! Votez quand même : entre le 6 et 9 juin 2024, les citoyens européens sont appelés aux urnes. #VoteAnyway',
                        link: 'https://www.vote-anyway.org/fr',
                        target: 'All',
                        status: 'Enabled',
                        button: 'LearnMore',
                        id: 'VOTE_ANYWAY_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Vote anyway',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_reveal_01.jpg',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'de',
                        teaserDisabled: true,
                        text: 'Vote Anyway! Wähl trotzdem: vom 6. zum 9. Juni 2024 werden die Europäer:innen zur Wahl aufgerufen. #VoteAnyway',
                        link: 'https://www.vote-anyway.org/de',
                        target: 'All',
                        status: 'Enabled',
                        button: 'LearnMore',
                        id: 'VOTE_ANYWAY_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Vote anyway',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_reveal_01.jpg',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'es',
                        teaserDisabled: true,
                        text: 'Vote anyway! Vota de todas formas: entre el 6 y 9 de junio de 2024, los ciudadanos europeos están llamados a las urnas. #VoteAnyway',
                        link: 'https://www.vote-anyway.org/',
                        target: 'All',
                        status: 'Enabled',
                        button: 'LearnMore',
                        id: 'VOTE_ANYWAY_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Vote anyway',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_reveal_01.jpg',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'it',
                        teaserDisabled: true,
                        text: 'Vote anyway! Votate comunque: tra il 6 e il 9 giugno 2024, i cittadini europei sono chiamati alle urne. #VoteAnyway',
                        link: 'https://www.vote-anyway.org/',
                        target: 'All',
                        status: 'Enabled',
                        button: 'LearnMore',
                        id: 'VOTE_ANYWAY_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Vote anyway',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_reveal_01.jpg',
                                type: 'Image'
                            },
                        ]
                    },
                ]
            },
            {
                name: 'Vote anyway',
                language: 'DEFAULT',
                target: 'All',
                customization: {
                    background: {
                        type: 'Image',
                        sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_teasing_01.jpg',
                        id: 'campaign_customization_background_vote_anyway_teasing_01'
                    },
                    logo: {
                        thumbnail: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                        sourceUrl: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                    }
                },
                promotions: [
                    {
                        language: 'en',
                        teaserDisabled: true,
                        text: 'Vote anyway! Between June 6 and 9, 2024, European citizens are called to the polls. #VoteAnyway',
                        link: 'https://www.vote-anyway.org/',
                        target: 'All',
                        status: 'Enabled',
                        button: 'LearnMore',
                        id: 'VOTE_ANYWAY_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Vote anyway',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_reveal_01.jpg',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'fr',
                        teaserDisabled: true,
                        text: 'Vote anyway! Votez quand même : entre le 6 et 9 juin 2024, les citoyens européens sont appelés aux urnes. #VoteAnyway',
                        link: 'https://www.vote-anyway.org/fr',
                        target: 'All',
                        status: 'Enabled',
                        button: 'LearnMore',
                        id: 'VOTE_ANYWAY_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Vote anyway',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_reveal_01.jpg',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'de',
                        teaserDisabled: true,
                        text: 'Vote Anyway! Wähl trotzdem: vom 6. zum 9. Juni 2024 werden die Europäer:innen zur Wahl aufgerufen. #VoteAnyway',
                        link: 'https://www.vote-anyway.org/de',
                        target: 'All',
                        status: 'Enabled',
                        button: 'LearnMore',
                        id: 'VOTE_ANYWAY_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Vote anyway',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_reveal_01.jpg',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'es',
                        teaserDisabled: true,
                        text: 'Vote anyway! Vota de todas formas: entre el 6 y 9 de junio de 2024, los ciudadanos europeos están llamados a las urnas. #VoteAnyway',
                        link: 'https://www.vote-anyway.org/',
                        target: 'All',
                        status: 'Enabled',
                        button: 'LearnMore',
                        id: 'VOTE_ANYWAY_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Vote anyway',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_reveal_01.jpg',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'it',
                        teaserDisabled: true,
                        text: 'Vote anyway! Votate comunque: tra il 6 e il 9 giugno 2024, i cittadini europei sono chiamati alle urne. #VoteAnyway',
                        link: 'https://www.vote-anyway.org/',
                        target: 'All',
                        status: 'Enabled',
                        button: 'LearnMore',
                        id: 'VOTE_ANYWAY_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Vote anyway',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_reveal_01.jpg',
                                type: 'Image'
                            },
                        ]
                    },
                ]
            },
            {
                name: 'Vote anyway',
                language: 'DEFAULT',
                target: 'All',
                customization: {
                    background: {
                        type: 'Image',
                        sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_teasing_01.jpg',
                        id: 'campaign_customization_background_vote_anyway_teasing_01'
                    },
                    logo: {
                        thumbnail: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                        sourceUrl: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                    }
                },
                promotions: [
                    {
                        language: 'en',
                        teaserDisabled: true,
                        text: 'Vote anyway! Between June 6 and 9, 2024, European citizens are called to the polls. #VoteAnyway',
                        link: 'https://www.vote-anyway.org/',
                        target: 'All',
                        status: 'Enabled',
                        button: 'LearnMore',
                        id: 'VOTE_ANYWAY_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Vote anyway',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_reveal_01.jpg',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'fr',
                        teaserDisabled: true,
                        text: 'Vote anyway! Votez quand même : entre le 6 et 9 juin 2024, les citoyens européens sont appelés aux urnes. #VoteAnyway',
                        link: 'https://www.vote-anyway.org/fr',
                        target: 'All',
                        status: 'Enabled',
                        button: 'LearnMore',
                        id: 'VOTE_ANYWAY_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Vote anyway',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_reveal_01.jpg',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'de',
                        teaserDisabled: true,
                        text: 'Vote Anyway! Wähl trotzdem: vom 6. zum 9. Juni 2024 werden die Europäer:innen zur Wahl aufgerufen. #VoteAnyway',
                        link: 'https://www.vote-anyway.org/de',
                        target: 'All',
                        status: 'Enabled',
                        button: 'LearnMore',
                        id: 'VOTE_ANYWAY_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Vote anyway',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_reveal_01.jpg',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'es',
                        teaserDisabled: true,
                        text: 'Vote anyway! Vota de todas formas: entre el 6 y 9 de junio de 2024, los ciudadanos europeos están llamados a las urnas. #VoteAnyway',
                        link: 'https://www.vote-anyway.org/',
                        target: 'All',
                        status: 'Enabled',
                        button: 'LearnMore',
                        id: 'VOTE_ANYWAY_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Vote anyway',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_reveal_01.jpg',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'it',
                        teaserDisabled: true,
                        text: 'Vote anyway! Votate comunque: tra il 6 e il 9 giugno 2024, i cittadini europei sono chiamati alle urne. #VoteAnyway',
                        link: 'https://www.vote-anyway.org/',
                        target: 'All',
                        status: 'Enabled',
                        button: 'LearnMore',
                        id: 'VOTE_ANYWAY_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Vote anyway',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_reveal_01.jpg',
                                type: 'Image'
                            },
                        ]
                    },
                ]
            },
            {
                name: 'Vote anyway',
                language: 'DEFAULT',
                target: 'All',
                customization: {
                    background: {
                        type: 'Image',
                        sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_teasing_01.jpg',
                        id: 'campaign_customization_background_vote_anyway_teasing_01'
                    },
                    logo: {
                        thumbnail: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                        sourceUrl: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                    }
                },
                promotions: [
                    {
                        language: 'en',
                        teaserDisabled: true,
                        text: 'Vote anyway! Between June 6 and 9, 2024, European citizens are called to the polls. #VoteAnyway',
                        link: 'https://www.vote-anyway.org/',
                        target: 'All',
                        status: 'Enabled',
                        button: 'LearnMore',
                        id: 'VOTE_ANYWAY_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Vote anyway',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_reveal_01.jpg',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'fr',
                        teaserDisabled: true,
                        text: 'Vote anyway! Votez quand même : entre le 6 et 9 juin 2024, les citoyens européens sont appelés aux urnes. #VoteAnyway',
                        link: 'https://www.vote-anyway.org/fr',
                        target: 'All',
                        status: 'Enabled',
                        button: 'LearnMore',
                        id: 'VOTE_ANYWAY_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Vote anyway',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_reveal_01.jpg',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'de',
                        teaserDisabled: true,
                        text: 'Vote Anyway! Wähl trotzdem: vom 6. zum 9. Juni 2024 werden die Europäer:innen zur Wahl aufgerufen. #VoteAnyway',
                        link: 'https://www.vote-anyway.org/de',
                        target: 'All',
                        status: 'Enabled',
                        button: 'LearnMore',
                        id: 'VOTE_ANYWAY_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Vote anyway',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_reveal_01.jpg',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'es',
                        teaserDisabled: true,
                        text: 'Vote anyway! Vota de todas formas: entre el 6 y 9 de junio de 2024, los ciudadanos europeos están llamados a las urnas. #VoteAnyway',
                        link: 'https://www.vote-anyway.org/',
                        target: 'All',
                        status: 'Enabled',
                        button: 'LearnMore',
                        id: 'VOTE_ANYWAY_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Vote anyway',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_reveal_01.jpg',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'it',
                        teaserDisabled: true,
                        text: 'Vote anyway! Votate comunque: tra il 6 e il 9 giugno 2024, i cittadini europei sono chiamati alle urne. #VoteAnyway',
                        link: 'https://www.vote-anyway.org/',
                        target: 'All',
                        status: 'Enabled',
                        button: 'LearnMore',
                        id: 'VOTE_ANYWAY_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Vote anyway',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_reveal_01.jpg',
                                type: 'Image'
                            },
                        ]
                    },
                ]
            },
        ],
        IT: [
            // Crazy Days
            {
                name: 'Offre spéciale 1',
                language: 'DEFAULT',
                target: 'All',
                customization: {
                    background: {
                        type: 'Image',
                        sourceUrl: 'assets/campaigns/smash/crazydays/Smash_Teasing_01.png',
                        id: 'campaign_offre_customization_background_desktop'
                    },
                    logo: {
                        thumbnail: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                        sourceUrl: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                    }
                },
                promotions: [
                    {
                        language: 'fr',
                        teaserDisabled: true,
                        text: 'Découvrez dès maintenant l\'offre spéciale. Offre à durée limitée.',
                        link: 'https://fromsmash.com/fr/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/FR.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'en',
                        teaserDisabled: true,
                        text: 'Discover the limited-time offer now.',
                        link: 'https://fromsmash.com/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/EN.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'es',
                        teaserDisabled: true,
                        text: 'Descubra ahora la oferta por tiempo limitado.',
                        link: 'https://fromsmash.com/es/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/ES.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'de',
                        teaserDisabled: true,
                        text: 'Entdecken Sie jetzt das zeitlich begrenzte Angebot.',
                        link: 'https://fromsmash.com/de/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/DE.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'it',
                        teaserDisabled: true,
                        text: 'Scoprite subito l\'offerta a tempo limitato.',
                        link: 'https://fromsmash.com/it/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/IT.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'pt',
                        teaserDisabled: true,
                        text: 'Descubra agora a oferta de tempo limitado.',
                        link: 'https://fromsmash.com/pt/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/PT.png',
                                type: 'Image'
                            },
                        ]
                    }
                ]
            },
            {
                name: 'Offre spéciale 2',
                language: 'DEFAULT',
                target: 'All',
                customization: {
                    background: {
                        type: 'Image',
                        sourceUrl: 'assets/campaigns/smash/crazydays/Smash_Teasing_02.png',
                        id: 'campaign_offre_customization_background_desktop'
                    },
                    logo: {
                        thumbnail: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                        sourceUrl: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                    }
                },
                promotions: [
                    {
                        language: 'fr',
                        teaserDisabled: true,
                        text: 'Découvrez dès maintenant l\'offre spéciale. Offre à durée limitée.',
                        link: 'https://fromsmash.com/fr/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/FR.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'en',
                        teaserDisabled: true,
                        text: 'Discover the limited-time offer now.',
                        link: 'https://fromsmash.com/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/EN.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'es',
                        teaserDisabled: true,
                        text: 'Descubra ahora la oferta por tiempo limitado.',
                        link: 'https://fromsmash.com/es/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/ES.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'de',
                        teaserDisabled: true,
                        text: 'Entdecken Sie jetzt das zeitlich begrenzte Angebot.',
                        link: 'https://fromsmash.com/de/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/DE.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'it',
                        teaserDisabled: true,
                        text: 'Scoprite subito l\'offerta a tempo limitato.',
                        link: 'https://fromsmash.com/it/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/IT.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'pt',
                        teaserDisabled: true,
                        text: 'Descubra agora a oferta de tempo limitado.',
                        link: 'https://fromsmash.com/pt/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/PT.png',
                                type: 'Image'
                            },
                        ]
                    }
                ]
            },
            {
                name: 'Offre spéciale 3',
                language: 'DEFAULT',
                target: 'All',
                customization: {
                    background: {
                        type: 'Image',
                        sourceUrl: 'assets/campaigns/smash/crazydays/Smash_Teasing_03.png',
                        id: 'campaign_offre_customization_background_desktop'
                    },
                    logo: {
                        thumbnail: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                        sourceUrl: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                    }
                },
                promotions: [
                    {
                        language: 'fr',
                        teaserDisabled: true,
                        text: 'Découvrez dès maintenant l\'offre spéciale. Offre à durée limitée.',
                        link: 'https://fromsmash.com/fr/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/FR.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'en',
                        teaserDisabled: true,
                        text: 'Discover the limited-time offer now.',
                        link: 'https://fromsmash.com/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/EN.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'es',
                        teaserDisabled: true,
                        text: 'Descubra ahora la oferta por tiempo limitado.',
                        link: 'https://fromsmash.com/es/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/ES.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'de',
                        teaserDisabled: true,
                        text: 'Entdecken Sie jetzt das zeitlich begrenzte Angebot.',
                        link: 'https://fromsmash.com/de/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/DE.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'it',
                        teaserDisabled: true,
                        text: 'Scoprite subito l\'offerta a tempo limitato.',
                        link: 'https://fromsmash.com/it/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/IT.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'pt',
                        teaserDisabled: true,
                        text: 'Descubra agora a oferta de tempo limitado.',
                        link: 'https://fromsmash.com/pt/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/PT.png',
                                type: 'Image'
                            },
                        ]
                    }
                ]
            },
            {
                name: 'Offre spéciale 4',
                language: 'DEFAULT',
                target: 'All',
                customization: {
                    background: {
                        type: 'Image',
                        sourceUrl: 'assets/campaigns/smash/crazydays/Smash_Teasing_04.png',
                        id: 'campaign_offre_customization_background_desktop'
                    },
                    logo: {
                        thumbnail: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                        sourceUrl: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                    }
                },
                promotions: [
                    {
                        language: 'fr',
                        teaserDisabled: true,
                        text: 'Découvrez dès maintenant l\'offre spéciale. Offre à durée limitée.',
                        link: 'https://fromsmash.com/fr/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/FR.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'en',
                        teaserDisabled: true,
                        text: 'Discover the limited-time offer now.',
                        link: 'https://fromsmash.com/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/EN.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'es',
                        teaserDisabled: true,
                        text: 'Descubra ahora la oferta por tiempo limitado.',
                        link: 'https://fromsmash.com/es/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/ES.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'de',
                        teaserDisabled: true,
                        text: 'Entdecken Sie jetzt das zeitlich begrenzte Angebot.',
                        link: 'https://fromsmash.com/de/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/DE.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'it',
                        teaserDisabled: true,
                        text: 'Scoprite subito l\'offerta a tempo limitato.',
                        link: 'https://fromsmash.com/it/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/IT.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'pt',
                        teaserDisabled: true,
                        text: 'Descubra agora a oferta de tempo limitado.',
                        link: 'https://fromsmash.com/pt/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/PT.png',
                                type: 'Image'
                            },
                        ]
                    }
                ]
            },

            // Vote Anyway
            {
                name: 'Vote anyway',
                language: 'DEFAULT',
                target: 'All',
                customization: {
                    background: {
                        type: 'Image',
                        sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_teasing_01.jpg',
                        id: 'campaign_customization_background_vote_anyway_teasing_01'
                    },
                    logo: {
                        thumbnail: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                        sourceUrl: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                    }
                },
                promotions: [
                    {
                        language: 'en',
                        teaserDisabled: true,
                        text: 'Vote anyway! Between June 6 and 9, 2024, European citizens are called to the polls. #VoteAnyway',
                        link: 'https://www.vote-anyway.org/',
                        target: 'All',
                        status: 'Enabled',
                        button: 'LearnMore',
                        id: 'VOTE_ANYWAY_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Vote anyway',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_reveal_01.jpg',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'fr',
                        teaserDisabled: true,
                        text: 'Vote anyway! Votez quand même : entre le 6 et 9 juin 2024, les citoyens européens sont appelés aux urnes. #VoteAnyway',
                        link: 'https://www.vote-anyway.org/fr',
                        target: 'All',
                        status: 'Enabled',
                        button: 'LearnMore',
                        id: 'VOTE_ANYWAY_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Vote anyway',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_reveal_01.jpg',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'de',
                        teaserDisabled: true,
                        text: 'Vote Anyway! Wähl trotzdem: vom 6. zum 9. Juni 2024 werden die Europäer:innen zur Wahl aufgerufen. #VoteAnyway',
                        link: 'https://www.vote-anyway.org/de',
                        target: 'All',
                        status: 'Enabled',
                        button: 'LearnMore',
                        id: 'VOTE_ANYWAY_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Vote anyway',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_reveal_01.jpg',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'es',
                        teaserDisabled: true,
                        text: 'Vote anyway! Vota de todas formas: entre el 6 y 9 de junio de 2024, los ciudadanos europeos están llamados a las urnas. #VoteAnyway',
                        link: 'https://www.vote-anyway.org/',
                        target: 'All',
                        status: 'Enabled',
                        button: 'LearnMore',
                        id: 'VOTE_ANYWAY_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Vote anyway',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_reveal_01.jpg',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'it',
                        teaserDisabled: true,
                        text: 'Vote anyway! Votate comunque: tra il 6 e il 9 giugno 2024, i cittadini europei sono chiamati alle urne. #VoteAnyway',
                        link: 'https://www.vote-anyway.org/',
                        target: 'All',
                        status: 'Enabled',
                        button: 'LearnMore',
                        id: 'VOTE_ANYWAY_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Vote anyway',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_reveal_01.jpg',
                                type: 'Image'
                            },
                        ]
                    },
                ]
            },
            {
                name: 'Vote anyway',
                language: 'DEFAULT',
                target: 'All',
                customization: {
                    background: {
                        type: 'Image',
                        sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_teasing_01.jpg',
                        id: 'campaign_customization_background_vote_anyway_teasing_01'
                    },
                    logo: {
                        thumbnail: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                        sourceUrl: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                    }
                },
                promotions: [
                    {
                        language: 'en',
                        teaserDisabled: true,
                        text: 'Vote anyway! Between June 6 and 9, 2024, European citizens are called to the polls. #VoteAnyway',
                        link: 'https://www.vote-anyway.org/',
                        target: 'All',
                        status: 'Enabled',
                        button: 'LearnMore',
                        id: 'VOTE_ANYWAY_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Vote anyway',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_reveal_01.jpg',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'fr',
                        teaserDisabled: true,
                        text: 'Vote anyway! Votez quand même : entre le 6 et 9 juin 2024, les citoyens européens sont appelés aux urnes. #VoteAnyway',
                        link: 'https://www.vote-anyway.org/fr',
                        target: 'All',
                        status: 'Enabled',
                        button: 'LearnMore',
                        id: 'VOTE_ANYWAY_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Vote anyway',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_reveal_01.jpg',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'de',
                        teaserDisabled: true,
                        text: 'Vote Anyway! Wähl trotzdem: vom 6. zum 9. Juni 2024 werden die Europäer:innen zur Wahl aufgerufen. #VoteAnyway',
                        link: 'https://www.vote-anyway.org/de',
                        target: 'All',
                        status: 'Enabled',
                        button: 'LearnMore',
                        id: 'VOTE_ANYWAY_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Vote anyway',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_reveal_01.jpg',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'es',
                        teaserDisabled: true,
                        text: 'Vote anyway! Vota de todas formas: entre el 6 y 9 de junio de 2024, los ciudadanos europeos están llamados a las urnas. #VoteAnyway',
                        link: 'https://www.vote-anyway.org/',
                        target: 'All',
                        status: 'Enabled',
                        button: 'LearnMore',
                        id: 'VOTE_ANYWAY_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Vote anyway',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_reveal_01.jpg',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'it',
                        teaserDisabled: true,
                        text: 'Vote anyway! Votate comunque: tra il 6 e il 9 giugno 2024, i cittadini europei sono chiamati alle urne. #VoteAnyway',
                        link: 'https://www.vote-anyway.org/',
                        target: 'All',
                        status: 'Enabled',
                        button: 'LearnMore',
                        id: 'VOTE_ANYWAY_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Vote anyway',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_reveal_01.jpg',
                                type: 'Image'
                            },
                        ]
                    },
                ]
            },
            {
                name: 'Vote anyway',
                language: 'DEFAULT',
                target: 'All',
                customization: {
                    background: {
                        type: 'Image',
                        sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_teasing_01.jpg',
                        id: 'campaign_customization_background_vote_anyway_teasing_01'
                    },
                    logo: {
                        thumbnail: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                        sourceUrl: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                    }
                },
                promotions: [
                    {
                        language: 'en',
                        teaserDisabled: true,
                        text: 'Vote anyway! Between June 6 and 9, 2024, European citizens are called to the polls. #VoteAnyway',
                        link: 'https://www.vote-anyway.org/',
                        target: 'All',
                        status: 'Enabled',
                        button: 'LearnMore',
                        id: 'VOTE_ANYWAY_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Vote anyway',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_reveal_01.jpg',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'fr',
                        teaserDisabled: true,
                        text: 'Vote anyway! Votez quand même : entre le 6 et 9 juin 2024, les citoyens européens sont appelés aux urnes. #VoteAnyway',
                        link: 'https://www.vote-anyway.org/fr',
                        target: 'All',
                        status: 'Enabled',
                        button: 'LearnMore',
                        id: 'VOTE_ANYWAY_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Vote anyway',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_reveal_01.jpg',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'de',
                        teaserDisabled: true,
                        text: 'Vote Anyway! Wähl trotzdem: vom 6. zum 9. Juni 2024 werden die Europäer:innen zur Wahl aufgerufen. #VoteAnyway',
                        link: 'https://www.vote-anyway.org/de',
                        target: 'All',
                        status: 'Enabled',
                        button: 'LearnMore',
                        id: 'VOTE_ANYWAY_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Vote anyway',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_reveal_01.jpg',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'es',
                        teaserDisabled: true,
                        text: 'Vote anyway! Vota de todas formas: entre el 6 y 9 de junio de 2024, los ciudadanos europeos están llamados a las urnas. #VoteAnyway',
                        link: 'https://www.vote-anyway.org/',
                        target: 'All',
                        status: 'Enabled',
                        button: 'LearnMore',
                        id: 'VOTE_ANYWAY_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Vote anyway',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_reveal_01.jpg',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'it',
                        teaserDisabled: true,
                        text: 'Vote anyway! Votate comunque: tra il 6 e il 9 giugno 2024, i cittadini europei sono chiamati alle urne. #VoteAnyway',
                        link: 'https://www.vote-anyway.org/',
                        target: 'All',
                        status: 'Enabled',
                        button: 'LearnMore',
                        id: 'VOTE_ANYWAY_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Vote anyway',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_reveal_01.jpg',
                                type: 'Image'
                            },
                        ]
                    },
                ]
            },
            {
                name: 'Vote anyway',
                language: 'DEFAULT',
                target: 'All',
                customization: {
                    background: {
                        type: 'Image',
                        sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_teasing_01.jpg',
                        id: 'campaign_customization_background_vote_anyway_teasing_01'
                    },
                    logo: {
                        thumbnail: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                        sourceUrl: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                    }
                },
                promotions: [
                    {
                        language: 'en',
                        teaserDisabled: true,
                        text: 'Vote anyway! Between June 6 and 9, 2024, European citizens are called to the polls. #VoteAnyway',
                        link: 'https://www.vote-anyway.org/',
                        target: 'All',
                        status: 'Enabled',
                        button: 'LearnMore',
                        id: 'VOTE_ANYWAY_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Vote anyway',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_reveal_01.jpg',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'fr',
                        teaserDisabled: true,
                        text: 'Vote anyway! Votez quand même : entre le 6 et 9 juin 2024, les citoyens européens sont appelés aux urnes. #VoteAnyway',
                        link: 'https://www.vote-anyway.org/fr',
                        target: 'All',
                        status: 'Enabled',
                        button: 'LearnMore',
                        id: 'VOTE_ANYWAY_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Vote anyway',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_reveal_01.jpg',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'de',
                        teaserDisabled: true,
                        text: 'Vote Anyway! Wähl trotzdem: vom 6. zum 9. Juni 2024 werden die Europäer:innen zur Wahl aufgerufen. #VoteAnyway',
                        link: 'https://www.vote-anyway.org/de',
                        target: 'All',
                        status: 'Enabled',
                        button: 'LearnMore',
                        id: 'VOTE_ANYWAY_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Vote anyway',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_reveal_01.jpg',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'es',
                        teaserDisabled: true,
                        text: 'Vote anyway! Vota de todas formas: entre el 6 y 9 de junio de 2024, los ciudadanos europeos están llamados a las urnas. #VoteAnyway',
                        link: 'https://www.vote-anyway.org/',
                        target: 'All',
                        status: 'Enabled',
                        button: 'LearnMore',
                        id: 'VOTE_ANYWAY_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Vote anyway',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_reveal_01.jpg',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'it',
                        teaserDisabled: true,
                        text: 'Vote anyway! Votate comunque: tra il 6 e il 9 giugno 2024, i cittadini europei sono chiamati alle urne. #VoteAnyway',
                        link: 'https://www.vote-anyway.org/',
                        target: 'All',
                        status: 'Enabled',
                        button: 'LearnMore',
                        id: 'VOTE_ANYWAY_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Vote anyway',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_reveal_01.jpg',
                                type: 'Image'
                            },
                        ]
                    },
                ]
            },
        ],
        DE: [
            // Crazy Days
            {
                name: 'Offre spéciale 1',
                language: 'DEFAULT',
                target: 'All',
                customization: {
                    background: {
                        type: 'Image',
                        sourceUrl: 'assets/campaigns/smash/crazydays/Smash_Teasing_01.png',
                        id: 'campaign_offre_customization_background_desktop'
                    },
                    logo: {
                        thumbnail: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                        sourceUrl: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                    }
                },
                promotions: [
                    {
                        language: 'fr',
                        teaserDisabled: true,
                        text: 'Découvrez dès maintenant l\'offre spéciale. Offre à durée limitée.',
                        link: 'https://fromsmash.com/fr/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/FR.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'en',
                        teaserDisabled: true,
                        text: 'Discover the limited-time offer now.',
                        link: 'https://fromsmash.com/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/EN.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'es',
                        teaserDisabled: true,
                        text: 'Descubra ahora la oferta por tiempo limitado.',
                        link: 'https://fromsmash.com/es/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/ES.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'de',
                        teaserDisabled: true,
                        text: 'Entdecken Sie jetzt das zeitlich begrenzte Angebot.',
                        link: 'https://fromsmash.com/de/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/DE.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'it',
                        teaserDisabled: true,
                        text: 'Scoprite subito l\'offerta a tempo limitato.',
                        link: 'https://fromsmash.com/it/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/IT.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'pt',
                        teaserDisabled: true,
                        text: 'Descubra agora a oferta de tempo limitado.',
                        link: 'https://fromsmash.com/pt/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/PT.png',
                                type: 'Image'
                            },
                        ]
                    }
                ]
            },
            {
                name: 'Offre spéciale 2',
                language: 'DEFAULT',
                target: 'All',
                customization: {
                    background: {
                        type: 'Image',
                        sourceUrl: 'assets/campaigns/smash/crazydays/Smash_Teasing_02.png',
                        id: 'campaign_offre_customization_background_desktop'
                    },
                    logo: {
                        thumbnail: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                        sourceUrl: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                    }
                },
                promotions: [
                    {
                        language: 'fr',
                        teaserDisabled: true,
                        text: 'Découvrez dès maintenant l\'offre spéciale. Offre à durée limitée.',
                        link: 'https://fromsmash.com/fr/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/FR.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'en',
                        teaserDisabled: true,
                        text: 'Discover the limited-time offer now.',
                        link: 'https://fromsmash.com/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/EN.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'es',
                        teaserDisabled: true,
                        text: 'Descubra ahora la oferta por tiempo limitado.',
                        link: 'https://fromsmash.com/es/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/ES.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'de',
                        teaserDisabled: true,
                        text: 'Entdecken Sie jetzt das zeitlich begrenzte Angebot.',
                        link: 'https://fromsmash.com/de/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/DE.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'it',
                        teaserDisabled: true,
                        text: 'Scoprite subito l\'offerta a tempo limitato.',
                        link: 'https://fromsmash.com/it/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/IT.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'pt',
                        teaserDisabled: true,
                        text: 'Descubra agora a oferta de tempo limitado.',
                        link: 'https://fromsmash.com/pt/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/PT.png',
                                type: 'Image'
                            },
                        ]
                    }
                ]
            },
            {
                name: 'Offre spéciale 3',
                language: 'DEFAULT',
                target: 'All',
                customization: {
                    background: {
                        type: 'Image',
                        sourceUrl: 'assets/campaigns/smash/crazydays/Smash_Teasing_03.png',
                        id: 'campaign_offre_customization_background_desktop'
                    },
                    logo: {
                        thumbnail: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                        sourceUrl: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                    }
                },
                promotions: [
                    {
                        language: 'fr',
                        teaserDisabled: true,
                        text: 'Découvrez dès maintenant l\'offre spéciale. Offre à durée limitée.',
                        link: 'https://fromsmash.com/fr/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/FR.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'en',
                        teaserDisabled: true,
                        text: 'Discover the limited-time offer now.',
                        link: 'https://fromsmash.com/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/EN.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'es',
                        teaserDisabled: true,
                        text: 'Descubra ahora la oferta por tiempo limitado.',
                        link: 'https://fromsmash.com/es/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/ES.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'de',
                        teaserDisabled: true,
                        text: 'Entdecken Sie jetzt das zeitlich begrenzte Angebot.',
                        link: 'https://fromsmash.com/de/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/DE.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'it',
                        teaserDisabled: true,
                        text: 'Scoprite subito l\'offerta a tempo limitato.',
                        link: 'https://fromsmash.com/it/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/IT.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'pt',
                        teaserDisabled: true,
                        text: 'Descubra agora a oferta de tempo limitado.',
                        link: 'https://fromsmash.com/pt/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/PT.png',
                                type: 'Image'
                            },
                        ]
                    }
                ]
            },
            {
                name: 'Offre spéciale 4',
                language: 'DEFAULT',
                target: 'All',
                customization: {
                    background: {
                        type: 'Image',
                        sourceUrl: 'assets/campaigns/smash/crazydays/Smash_Teasing_04.png',
                        id: 'campaign_offre_customization_background_desktop'
                    },
                    logo: {
                        thumbnail: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                        sourceUrl: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                    }
                },
                promotions: [
                    {
                        language: 'fr',
                        teaserDisabled: true,
                        text: 'Découvrez dès maintenant l\'offre spéciale. Offre à durée limitée.',
                        link: 'https://fromsmash.com/fr/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/FR.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'en',
                        teaserDisabled: true,
                        text: 'Discover the limited-time offer now.',
                        link: 'https://fromsmash.com/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/EN.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'es',
                        teaserDisabled: true,
                        text: 'Descubra ahora la oferta por tiempo limitado.',
                        link: 'https://fromsmash.com/es/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/ES.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'de',
                        teaserDisabled: true,
                        text: 'Entdecken Sie jetzt das zeitlich begrenzte Angebot.',
                        link: 'https://fromsmash.com/de/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/DE.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'it',
                        teaserDisabled: true,
                        text: 'Scoprite subito l\'offerta a tempo limitato.',
                        link: 'https://fromsmash.com/it/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/IT.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'pt',
                        teaserDisabled: true,
                        text: 'Descubra agora a oferta de tempo limitado.',
                        link: 'https://fromsmash.com/pt/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/PT.png',
                                type: 'Image'
                            },
                        ]
                    }
                ]
            },

            // Vote Anyway
            {
                name: 'Vote anyway',
                language: 'DEFAULT',
                target: 'All',
                customization: {
                    background: {
                        type: 'Image',
                        sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_teasing_01.jpg',
                        id: 'campaign_customization_background_vote_anyway_teasing_01'
                    },
                    logo: {
                        thumbnail: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                        sourceUrl: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                    }
                },
                promotions: [
                    {
                        language: 'en',
                        teaserDisabled: true,
                        text: 'Vote anyway! Between June 6 and 9, 2024, European citizens are called to the polls. #VoteAnyway',
                        link: 'https://www.vote-anyway.org/',
                        target: 'All',
                        status: 'Enabled',
                        button: 'LearnMore',
                        id: 'VOTE_ANYWAY_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Vote anyway',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_reveal_01.jpg',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'fr',
                        teaserDisabled: true,
                        text: 'Vote anyway! Votez quand même : entre le 6 et 9 juin 2024, les citoyens européens sont appelés aux urnes. #VoteAnyway',
                        link: 'https://www.vote-anyway.org/fr',
                        target: 'All',
                        status: 'Enabled',
                        button: 'LearnMore',
                        id: 'VOTE_ANYWAY_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Vote anyway',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_reveal_01.jpg',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'de',
                        teaserDisabled: true,
                        text: 'Vote Anyway! Wähl trotzdem: vom 6. zum 9. Juni 2024 werden die Europäer:innen zur Wahl aufgerufen. #VoteAnyway',
                        link: 'https://www.vote-anyway.org/de',
                        target: 'All',
                        status: 'Enabled',
                        button: 'LearnMore',
                        id: 'VOTE_ANYWAY_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Vote anyway',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_reveal_01.jpg',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'es',
                        teaserDisabled: true,
                        text: 'Vote anyway! Vota de todas formas: entre el 6 y 9 de junio de 2024, los ciudadanos europeos están llamados a las urnas. #VoteAnyway',
                        link: 'https://www.vote-anyway.org/',
                        target: 'All',
                        status: 'Enabled',
                        button: 'LearnMore',
                        id: 'VOTE_ANYWAY_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Vote anyway',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_reveal_01.jpg',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'it',
                        teaserDisabled: true,
                        text: 'Vote anyway! Votate comunque: tra il 6 e il 9 giugno 2024, i cittadini europei sono chiamati alle urne. #VoteAnyway',
                        link: 'https://www.vote-anyway.org/',
                        target: 'All',
                        status: 'Enabled',
                        button: 'LearnMore',
                        id: 'VOTE_ANYWAY_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Vote anyway',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_reveal_01.jpg',
                                type: 'Image'
                            },
                        ]
                    },
                ]
            },
            {
                name: 'Vote anyway',
                language: 'DEFAULT',
                target: 'All',
                customization: {
                    background: {
                        type: 'Image',
                        sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_teasing_01.jpg',
                        id: 'campaign_customization_background_vote_anyway_teasing_01'
                    },
                    logo: {
                        thumbnail: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                        sourceUrl: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                    }
                },
                promotions: [
                    {
                        language: 'en',
                        teaserDisabled: true,
                        text: 'Vote anyway! Between June 6 and 9, 2024, European citizens are called to the polls. #VoteAnyway',
                        link: 'https://www.vote-anyway.org/',
                        target: 'All',
                        status: 'Enabled',
                        button: 'LearnMore',
                        id: 'VOTE_ANYWAY_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Vote anyway',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_reveal_01.jpg',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'fr',
                        teaserDisabled: true,
                        text: 'Vote anyway! Votez quand même : entre le 6 et 9 juin 2024, les citoyens européens sont appelés aux urnes. #VoteAnyway',
                        link: 'https://www.vote-anyway.org/fr',
                        target: 'All',
                        status: 'Enabled',
                        button: 'LearnMore',
                        id: 'VOTE_ANYWAY_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Vote anyway',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_reveal_01.jpg',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'de',
                        teaserDisabled: true,
                        text: 'Vote Anyway! Wähl trotzdem: vom 6. zum 9. Juni 2024 werden die Europäer:innen zur Wahl aufgerufen. #VoteAnyway',
                        link: 'https://www.vote-anyway.org/de',
                        target: 'All',
                        status: 'Enabled',
                        button: 'LearnMore',
                        id: 'VOTE_ANYWAY_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Vote anyway',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_reveal_01.jpg',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'es',
                        teaserDisabled: true,
                        text: 'Vote anyway! Vota de todas formas: entre el 6 y 9 de junio de 2024, los ciudadanos europeos están llamados a las urnas. #VoteAnyway',
                        link: 'https://www.vote-anyway.org/',
                        target: 'All',
                        status: 'Enabled',
                        button: 'LearnMore',
                        id: 'VOTE_ANYWAY_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Vote anyway',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_reveal_01.jpg',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'it',
                        teaserDisabled: true,
                        text: 'Vote anyway! Votate comunque: tra il 6 e il 9 giugno 2024, i cittadini europei sono chiamati alle urne. #VoteAnyway',
                        link: 'https://www.vote-anyway.org/',
                        target: 'All',
                        status: 'Enabled',
                        button: 'LearnMore',
                        id: 'VOTE_ANYWAY_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Vote anyway',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_reveal_01.jpg',
                                type: 'Image'
                            },
                        ]
                    },
                ]
            },
            {
                name: 'Vote anyway',
                language: 'DEFAULT',
                target: 'All',
                customization: {
                    background: {
                        type: 'Image',
                        sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_teasing_01.jpg',
                        id: 'campaign_customization_background_vote_anyway_teasing_01'
                    },
                    logo: {
                        thumbnail: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                        sourceUrl: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                    }
                },
                promotions: [
                    {
                        language: 'en',
                        teaserDisabled: true,
                        text: 'Vote anyway! Between June 6 and 9, 2024, European citizens are called to the polls. #VoteAnyway',
                        link: 'https://www.vote-anyway.org/',
                        target: 'All',
                        status: 'Enabled',
                        button: 'LearnMore',
                        id: 'VOTE_ANYWAY_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Vote anyway',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_reveal_01.jpg',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'fr',
                        teaserDisabled: true,
                        text: 'Vote anyway! Votez quand même : entre le 6 et 9 juin 2024, les citoyens européens sont appelés aux urnes. #VoteAnyway',
                        link: 'https://www.vote-anyway.org/fr',
                        target: 'All',
                        status: 'Enabled',
                        button: 'LearnMore',
                        id: 'VOTE_ANYWAY_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Vote anyway',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_reveal_01.jpg',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'de',
                        teaserDisabled: true,
                        text: 'Vote Anyway! Wähl trotzdem: vom 6. zum 9. Juni 2024 werden die Europäer:innen zur Wahl aufgerufen. #VoteAnyway',
                        link: 'https://www.vote-anyway.org/de',
                        target: 'All',
                        status: 'Enabled',
                        button: 'LearnMore',
                        id: 'VOTE_ANYWAY_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Vote anyway',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_reveal_01.jpg',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'es',
                        teaserDisabled: true,
                        text: 'Vote anyway! Vota de todas formas: entre el 6 y 9 de junio de 2024, los ciudadanos europeos están llamados a las urnas. #VoteAnyway',
                        link: 'https://www.vote-anyway.org/',
                        target: 'All',
                        status: 'Enabled',
                        button: 'LearnMore',
                        id: 'VOTE_ANYWAY_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Vote anyway',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_reveal_01.jpg',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'it',
                        teaserDisabled: true,
                        text: 'Vote anyway! Votate comunque: tra il 6 e il 9 giugno 2024, i cittadini europei sono chiamati alle urne. #VoteAnyway',
                        link: 'https://www.vote-anyway.org/',
                        target: 'All',
                        status: 'Enabled',
                        button: 'LearnMore',
                        id: 'VOTE_ANYWAY_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Vote anyway',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_reveal_01.jpg',
                                type: 'Image'
                            },
                        ]
                    },
                ]
            },
            {
                name: 'Vote anyway',
                language: 'DEFAULT',
                target: 'All',
                customization: {
                    background: {
                        type: 'Image',
                        sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_teasing_01.jpg',
                        id: 'campaign_customization_background_vote_anyway_teasing_01'
                    },
                    logo: {
                        thumbnail: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                        sourceUrl: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                    }
                },
                promotions: [
                    {
                        language: 'en',
                        teaserDisabled: true,
                        text: 'Vote anyway! Between June 6 and 9, 2024, European citizens are called to the polls. #VoteAnyway',
                        link: 'https://www.vote-anyway.org/',
                        target: 'All',
                        status: 'Enabled',
                        button: 'LearnMore',
                        id: 'VOTE_ANYWAY_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Vote anyway',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_reveal_01.jpg',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'fr',
                        teaserDisabled: true,
                        text: 'Vote anyway! Votez quand même : entre le 6 et 9 juin 2024, les citoyens européens sont appelés aux urnes. #VoteAnyway',
                        link: 'https://www.vote-anyway.org/fr',
                        target: 'All',
                        status: 'Enabled',
                        button: 'LearnMore',
                        id: 'VOTE_ANYWAY_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Vote anyway',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_reveal_01.jpg',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'de',
                        teaserDisabled: true,
                        text: 'Vote Anyway! Wähl trotzdem: vom 6. zum 9. Juni 2024 werden die Europäer:innen zur Wahl aufgerufen. #VoteAnyway',
                        link: 'https://www.vote-anyway.org/de',
                        target: 'All',
                        status: 'Enabled',
                        button: 'LearnMore',
                        id: 'VOTE_ANYWAY_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Vote anyway',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_reveal_01.jpg',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'es',
                        teaserDisabled: true,
                        text: 'Vote anyway! Vota de todas formas: entre el 6 y 9 de junio de 2024, los ciudadanos europeos están llamados a las urnas. #VoteAnyway',
                        link: 'https://www.vote-anyway.org/',
                        target: 'All',
                        status: 'Enabled',
                        button: 'LearnMore',
                        id: 'VOTE_ANYWAY_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Vote anyway',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_reveal_01.jpg',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'it',
                        teaserDisabled: true,
                        text: 'Vote anyway! Votate comunque: tra il 6 e il 9 giugno 2024, i cittadini europei sono chiamati alle urne. #VoteAnyway',
                        link: 'https://www.vote-anyway.org/',
                        target: 'All',
                        status: 'Enabled',
                        button: 'LearnMore',
                        id: 'VOTE_ANYWAY_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Vote anyway',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/vote_anyway/vote_anyway_reveal_01.jpg',
                                type: 'Image'
                            },
                        ]
                    },
                ]
            },
        ],
        OTHER: [
            // SMASH - Outlook (only uploader)
            // {
            //     name: 'Outlook',
            //     language: 'FR',
            //     target: 'Uploader',
            //     customization: {
            //         background: {
            //             type: 'Image',
            //             sourceUrl: 'assets/campaigns/smash/outlook/customization/campaign_outlook_customization_background_desktop.png',
            //             id: 'campaign_outlook_customization_background_desktop'
            //         },
            //         logo: {
            //             thumbnail: 'assets/img/smash-logo/png/icono-chip-full-white.png',
            //             sourceUrl: 'assets/img/smash-logo/png/icono-chip-full-white.png',
            //         }
            //     },
            //     promotions: [
            //         {
            //             language: 'fr',
            //             teaserDisabled: true,
            //             text: 'Soyez informés en avant-première de la sortie de Smash pour Outlook !',
            //             link: 'https://fr.fromsmash.com/integrations/outlook',
            //             target: 'Internal',
            //             status: 'Enabled',
            //             button: 'Signup',
            //             id: 'OUTLOOK_PROMOTION_DESKTOP_INTERNAL',
            //             title: 'Outlook',
            //             medias: [
            //                 {
            //                     sourceUrl: 'assets/campaigns/smash/outlook/promotion/background_desktop_outlook_fr.png',
            //                     type: 'Image'
            //                 },
            //             ]
            //         },
            //         {
            //             language: 'fr',
            //             teaserDisabled: true,
            //             text: 'Soyez informés en avant-première de la sortie de Smash pour Outlook !',
            //             link: 'https://fr.fromsmash.com/integrations/outlook',
            //             target: 'External',
            //             status: 'Enabled',
            //             button: 'Signup',
            //             id: 'OUTLOOK_PROMOTION_DESKTOP_EXTERNAL',
            //             title: 'Outlook',
            //             medias: [
            //                 {
            //                     sourceUrl: 'assets/campaigns/smash/outlook/promotion/background_desktop_outlook_fr.png',
            //                     type: 'Image'
            //                 },
            //             ]
            //         },
            //     ]
            // },
            // {
            //     name: 'Outlook',
            //     language: 'ES',
            //     target: 'Uploader',
            //     customization: {
            //         background: {
            //             type: 'Image',
            //             sourceUrl: 'assets/campaigns/smash/outlook/customization/campaign_outlook_customization_background_desktop.png',
            //             id: 'campaign_outlook_customization_background_desktop'
            //         },
            //         logo: {
            //             thumbnail: 'assets/img/smash-logo/png/icono-chip-full-white.png',
            //             sourceUrl: 'assets/img/smash-logo/png/icono-chip-full-white.png',
            //         }
            //     },
            //     promotions: [
            //         {
            //             language: 'es',
            //             teaserDisabled: true,
            //             text: 'Sé el primero en enterarte del lanzamiento de Smash para Outlook!',
            //             link: 'https://es.fromsmash.com/integrations/outlook',
            //             target: 'Internal',
            //             status: 'Enabled',
            //             button: 'Signup',
            //             id: 'OUTLOOK_PROMOTION_DESKTOP_INTERNAL',
            //             title: 'Outlook',
            //             medias: [
            //                 {
            //                     sourceUrl: 'assets/campaigns/smash/outlook/promotion/background_desktop_outlook_es.png',
            //                     type: 'Image'
            //                 },
            //             ]
            //         },
            //         {
            //             language: 'es',
            //             teaserDisabled: true,
            //             text: '¡Sé el primero en enterarte del lanzamiento de Smash para Outlook!',
            //             link: 'https://es.fromsmash.com/integrations/outlook',
            //             target: 'External',
            //             status: 'Enabled',
            //             button: 'Signup',
            //             id: 'OUTLOOK_PROMOTION_DESKTOP_EXTERNAL',
            //             title: 'Outlook',
            //             medias: [
            //                 {
            //                     sourceUrl: 'assets/campaigns/smash/outlook/promotion/background_desktop_outlook_es.png',
            //                     type: 'Image'
            //                 },
            //             ]
            //         },
            //     ]
            // },
            // {
            //     name: 'Outlook',
            //     language: 'EN',
            //     target: 'Uploader',
            //     customization: {
            //         background: {
            //             type: 'Image',
            //             sourceUrl: 'assets/campaigns/smash/outlook/customization/campaign_outlook_customization_background_desktop.png',
            //             id: 'campaign_outlook_customization_background_desktop'
            //         },
            //         logo: {
            //             thumbnail: 'assets/img/smash-logo/png/icono-chip-full-white.png',
            //             sourceUrl: 'assets/img/smash-logo/png/icono-chip-full-white.png',
            //         }
            //     },
            //     promotions: [
            //         {
            //             language: 'en',
            //             teaserDisabled: true,
            //             text: 'Be the first informed of the release of Smash for Outlook!',
            //             link: 'https://en.fromsmash.com/integrations/outlook',
            //             target: 'Internal',
            //             status: 'Enabled',
            //             button: 'Signup',
            //             id: 'OUTLOOK_PROMOTION_DESKTOP_INTERNAL',
            //             title: 'Outlook',
            //             medias: [
            //                 {
            //                     sourceUrl: 'assets/campaigns/smash/outlook/promotion/background_desktop_outlook_en.png',
            //                     type: 'Image'
            //                 },
            //             ]
            //         },
            //         {
            //             language: 'en',
            //             teaserDisabled: true,
            //             text: 'Be the first informed of the release of Smash for Outlook!',
            //             link: 'https://en.fromsmash.com/integrations/outlook',
            //             target: 'External',
            //             status: 'Enabled',
            //             button: 'Signup',
            //             id: 'OUTLOOK_PROMOTION_DESKTOP_EXTERNAL',
            //             title: 'Outlook',
            //             medias: [
            //                 {
            //                     sourceUrl: 'assets/campaigns/smash/outlook/promotion/background_desktop_outlook_en.png',
            //                     type: 'Image'
            //                 },
            //             ]
            //         },
            //     ]
            // },
            // {
            //     name: 'Outlook',
            //     language: 'DE',
            //     target: 'Uploader',
            //     customization: {
            //         background: {
            //             type: 'Image',
            //             sourceUrl: 'assets/campaigns/smash/outlook/customization/campaign_outlook_customization_background_desktop.png',
            //             id: 'campaign_outlook_customization_background_desktop'
            //         },
            //         logo: {
            //             thumbnail: 'assets/img/smash-logo/png/icono-chip-full-white.png',
            //             sourceUrl: 'assets/img/smash-logo/png/icono-chip-full-white.png',
            //         }
            //     },
            //     promotions: [
            //         {
            //             language: 'de',
            //             teaserDisabled: true,
            //             text: 'Seien Sie der Erste, der über die Veröffentlichung von Smash for Outlook informiert wird!',
            //             link: 'https://fromsmash.com/de/integrations/outlook',
            //             target: 'Internal',
            //             status: 'Enabled',
            //             button: 'Signup',
            //             id: 'OUTLOOK_PROMOTION_DESKTOP_INTERNAL',
            //             title: 'Outlook',
            //             medias: [
            //                 {
            //                     sourceUrl: 'assets/campaigns/smash/outlook/promotion/background_desktop_outlook_de.png',
            //                     type: 'Image'
            //                 },
            //             ]
            //         },
            //         {
            //             language: 'de',
            //             teaserDisabled: true,
            //             text: 'Seien Sie der Erste, der über die Veröffentlichung von Smash for Outlook informiert wird!',
            //             link: 'https://fromsmash.com/de/integrations/outlook',
            //             target: 'External',
            //             status: 'Enabled',
            //             button: 'Signup',
            //             id: 'OUTLOOK_PROMOTION_DESKTOP_EXTERNAL',
            //             title: 'Outlook',
            //             medias: [
            //                 {
            //                     sourceUrl: 'assets/campaigns/smash/outlook/promotion/background_desktop_outlook_de.png',
            //                     type: 'Image'
            //                 },
            //             ]
            //         },
            //     ]
            // },
            // {
            //     name: 'Outlook',
            //     language: 'IT',
            //     target: 'Uploader',
            //     customization: {
            //         background: {
            //             type: 'Image',
            //             sourceUrl: 'assets/campaigns/smash/outlook/customization/campaign_outlook_customization_background_desktop.png',
            //             id: 'campaign_outlook_customization_background_desktop'
            //         },
            //         logo: {
            //             thumbnail: 'assets/img/smash-logo/png/icono-chip-full-white.png',
            //             sourceUrl: 'assets/img/smash-logo/png/icono-chip-full-white.png',
            //         }
            //     },
            //     promotions: [
            //         {
            //             language: 'it',
            //             teaserDisabled: true,
            //             text: 'Siate i primi ad essere informati del rilascio di Smash per Outlook!',
            //             link: 'https://it.fromsmash.com/integrations/outlook',
            //             target: 'Internal',
            //             status: 'Enabled',
            //             button: 'Signup',
            //             id: 'OUTLOOK_PROMOTION_DESKTOP_INTERNAL',
            //             title: 'Outlook',
            //             medias: [
            //                 {
            //                     sourceUrl: 'assets/campaigns/smash/outlook/promotion/background_desktop_outlook_it.png',
            //                     type: 'Image'
            //                 },
            //             ]
            //         },
            //         {
            //             language: 'it',
            //             teaserDisabled: true,
            //             text: 'Siate i primi ad essere informati del rilascio di Smash per Outlook!',
            //             link: 'https://it.fromsmash.com/integrations/outlook',
            //             target: 'External',
            //             status: 'Enabled',
            //             button: 'Signup',
            //             id: 'OUTLOOK_PROMOTION_DESKTOP_EXTERNAL',
            //             title: 'Outlook',
            //             medias: [
            //                 {
            //                     sourceUrl: 'assets/campaigns/smash/outlook/promotion/background_desktop_outlook_it.png',
            //                     type: 'Image'
            //                 },
            //             ]
            //         },
            //     ]
            // },
            // {
            //     name: 'Outlook',
            //     language: 'PT',
            //     target: 'Uploader',
            //     customization: {
            //         background: {
            //             type: 'Image',
            //             sourceUrl: 'assets/campaigns/smash/outlook/customization/campaign_outlook_customization_background_desktop.png',
            //             id: 'campaign_outlook_customization_background_desktop'
            //         },
            //         logo: {
            //             thumbnail: 'assets/img/smash-logo/png/icono-chip-full-white.png',
            //             sourceUrl: 'assets/img/smash-logo/png/icono-chip-full-white.png',
            //         }
            //     },
            //     promotions: [
            //         {
            //             language: 'pt',
            //             teaserDisabled: true,
            //             text: 'Seja o primeiro a ser informado sobre o lançamento do Smash para Outlook!',
            //             link: 'https://fromsmash.com/pt/integrations/outlook',
            //             target: 'Internal',
            //             status: 'Enabled',
            //             button: 'Signup',
            //             id: 'OUTLOOK_PROMOTION_DESKTOP_INTERNAL',
            //             title: 'Outlook',
            //             medias: [
            //                 {
            //                     sourceUrl: 'assets/campaigns/smash/outlook/promotion/background_desktop_outlook_pt.png',
            //                     type: 'Image'
            //                 },
            //             ]
            //         },
            //         {
            //             language: 'pt',
            //             teaserDisabled: true,
            //             text: 'Seja o primeiro a ser informado sobre o lançamento do Smash para Outlook!',
            //             link: 'https://fromsmash.com/pt/integrations/outlook',
            //             target: 'External',
            //             status: 'Enabled',
            //             button: 'Signup',
            //             id: 'OUTLOOK_PROMOTION_DESKTOP_EXTERNAL',
            //             title: 'Outlook',
            //             medias: [
            //                 {
            //                     sourceUrl: 'assets/campaigns/smash/outlook/promotion/background_desktop_outlook_pt.png',
            //                     type: 'Image'
            //                 },
            //             ]
            //         },
            //     ]
            // },
            // {
            //     name: 'Outlook',
            //     language: 'DEFAULT',
            //     target: 'Uploader',
            //     customization: {
            //         background: {
            //             type: 'Image',
            //             sourceUrl: 'assets/campaigns/smash/outlook/customization/campaign_outlook_customization_background_desktop.png',
            //             id: 'campaign_outlook_customization_background_desktop'
            //         },
            //         logo: {
            //             thumbnail: 'assets/img/smash-logo/png/icono-chip-full-white.png',
            //             sourceUrl: 'assets/img/smash-logo/png/icono-chip-full-white.png',
            //         }
            //     },
            //     promotions: [
            //         {
            //             language: 'en',
            //             teaserDisabled: true,
            //             text: 'Be the first informed of the release of Smash for Outlook!',
            //             link: 'https://en.fromsmash.com/integrations/outlook',
            //             target: 'Internal',
            //             status: 'Enabled',
            //             button: 'Signup',
            //             id: 'OUTLOOK_PROMOTION_DESKTOP_INTERNAL',
            //             title: 'Outlook',
            //             medias: [
            //                 {
            //                     sourceUrl: 'assets/campaigns/smash/outlook/promotion/background_desktop_outlook_en.png',
            //                     type: 'Image'
            //                 },
            //             ]
            //         },
            //         {
            //             language: 'en',
            //             teaserDisabled: true,
            //             text: 'Be the first informed of the release of Smash for Outlook!',
            //             link: 'https://en.fromsmash.com/integrations/outlook',
            //             target: 'External',
            //             status: 'Enabled',
            //             button: 'Signup',
            //             id: 'OUTLOOK_PROMOTION_DESKTOP_EXTERNAL',
            //             title: 'Outlook',
            //             medias: [
            //                 {
            //                     sourceUrl: 'assets/campaigns/smash/outlook/promotion/background_desktop_outlook_en.png',
            //                     type: 'Image'
            //                 },
            //             ]
            //         },
            //     ]
            // },
            // SMASH - Carbone (uploader)
            // {
            //     name: 'Carbone',
            //     language: 'FR',
            //     target: 'Uploader',
            //     customization: {
            //         background: {
            //             type: 'Image',
            //             sourceUrl: 'assets/campaigns/smash/carbone/customization/campaign_carbone_customization_background_desktop.png',
            //             id: 'campaign_carbone_customization_background_desktop'
            //         },
            //         logo: {
            //             thumbnail: 'assets/img/smash-logo/png/icono-chip-full-white.png',
            //             sourceUrl: 'assets/img/smash-logo/png/icono-chip-full-white.png',
            //         }
            //     },
            //     promotions: [
            //         {
            //             language: 'fr',
            //             teaserDisabled: true,
            //             text: 'Le numérique représente 4% des émissions de gaz à effet de serre mondiales. Alors privilégier l\'envoi de vos fichiers par Smash, c\'est mieux pour la planète.',
            //             link: 'https://fromsmash.com/fr/smashs-carbon-footprint',
            //             target: 'Internal',
            //             status: 'Enabled',
            //             button: 'LearnMore',
            //             id: 'CARBON_PROMOTION_DESKTOP_INTERNAL',
            //             title: 'Carbone',
            //             medias: [
            //                 {
            //                     sourceUrl: 'assets/campaigns/smash/carbone/promotion/background_desktop_carbone_fr.png',
            //                     type: 'Image'
            //                 },
            //             ]
            //         },
            //         {
            //             language: 'fr',
            //             teaserDisabled: true,
            //             text: 'Le numérique représente 4% des émissions de gaz à effet de serre mondiales. Alors privilégier l\'envoi de vos fichiers par Smash, c\'est mieux pour la planète.',
            //             link: 'https://fromsmash.com/fr/smashs-carbon-footprint',
            //             target: 'External',
            //             status: 'Enabled',
            //             button: 'LearnMore',
            //             id: 'CARBON_PROMOTION_DESKTOP_INTERNAL',
            //             title: 'Carbone',
            //             medias: [
            //                 {
            //                     sourceUrl: 'assets/campaigns/smash/carbone/promotion/background_desktop_carbone_fr.png',
            //                     type: 'Image'
            //                 },
            //             ]
            //         }
            //     ]
            // },
            // {
            //     name: 'Carbone',
            //     language: 'ES',
            //     target: 'Uploader',
            //     customization: {
            //         background: {
            //             type: 'Image',
            //             sourceUrl: 'assets/campaigns/smash/carbone/customization/campaign_carbone_customization_background_desktop.png',
            //             id: 'campaign_carbone_customization_background_desktop'
            //         },
            //         logo: {
            //             thumbnail: 'assets/img/smash-logo/png/icono-chip-full-white.png',
            //             sourceUrl: 'assets/img/smash-logo/png/icono-chip-full-white.png',
            //         }
            //     },
            //     promotions: [
            //         {
            //             language: 'es',
            //             teaserDisabled: true,
            //             text: 'La tecnología digital es responsable del 4% de las emisiones mundiales de gases de efecto invernadero. Así que, enviar tus archivos por Smash es mejor para el planeta.',
            //             link: 'https://fromsmash.com/es/smashs-carbon-footprint',
            //             target: 'Internal',
            //             status: 'Enabled',
            //             button: 'LearnMore',
            //             id: 'CARBON_PROMOTION_DESKTOP_INTERNAL',
            //             title: 'Carbone',
            //             medias: [
            //                 {
            //                     sourceUrl: 'assets/campaigns/smash/carbone/promotion/background_desktop_carbone_es.png',
            //                     type: 'Image'
            //                 },
            //             ]
            //         },
            //         {
            //             language: 'es',
            //             teaserDisabled: true,
            //             text: 'La tecnología digital es responsable del 4% de las emisiones mundiales de gases de efecto invernadero. Así que, enviar tus archivos por Smash es mejor para el planeta.',
            //             link: 'https://fromsmash.com/es/smashs-carbon-footprint',
            //             target: 'External',
            //             status: 'Enabled',
            //             button: 'LearnMore',
            //             id: 'CARBON_PROMOTION_DESKTOP_INTERNAL',
            //             title: 'Carbone',
            //             medias: [
            //                 {
            //                     sourceUrl: 'assets/campaigns/smash/carbone/promotion/background_desktop_carbone_es.png',
            //                     type: 'Image'
            //                 },
            //             ]
            //         }
            //     ]
            // },
            // {
            //     name: 'Carbone',
            //     language: 'EN',
            //     target: 'Uploader',
            //     customization: {
            //         background: {
            //             type: 'Image',
            //             sourceUrl: 'assets/campaigns/smash/carbone/customization/campaign_carbone_customization_background_desktop.png',
            //             id: 'campaign_carbone_customization_background_desktop'
            //         },
            //         logo: {
            //             thumbnail: 'assets/img/smash-logo/png/icono-chip-full-white.png',
            //             sourceUrl: 'assets/img/smash-logo/png/icono-chip-full-white.png',
            //         }
            //     },
            //     promotions: [
            //         {
            //             language: 'en',
            //             teaserDisabled: true,
            //             text: 'Digital technology accounts for 4% of global greenhouse gas emissions. So, sending your files by Smash is better for the planet.',
            //             link: 'https://fromsmash.com/smashs-carbon-footprint',
            //             target: 'Internal',
            //             status: 'Enabled',
            //             button: 'LearnMore',
            //             id: 'CARBON_PROMOTION_DESKTOP_INTERNAL',
            //             title: 'Carbone',
            //             medias: [
            //                 {
            //                     sourceUrl: 'assets/campaigns/smash/carbone/promotion/background_desktop_carbone_en.png',
            //                     type: 'Image'
            //                 },
            //             ]
            //         },
            //         {
            //             language: 'en',
            //             teaserDisabled: true,
            //             text: 'Digital technology accounts for 4% of global greenhouse gas emissions. So, sending your files by Smash is better for the planet.',
            //             link: 'https://fromsmash.com/smashs-carbon-footprint',
            //             target: 'External',
            //             status: 'Enabled',
            //             button: 'LearnMore',
            //             id: 'CARBON_PROMOTION_DESKTOP_INTERNAL',
            //             title: 'Carbone',
            //             medias: [
            //                 {
            //                     sourceUrl: 'assets/campaigns/smash/carbone/promotion/background_desktop_carbone_en.png',
            //                     type: 'Image'
            //                 },
            //             ]
            //         }
            //     ]
            // },
            // {
            //     name: 'Carbone',
            //     language: 'DE',
            //     target: 'Uploader',
            //     customization: {
            //         background: {
            //             type: 'Image',
            //             sourceUrl: 'assets/campaigns/smash/carbone/customization/campaign_carbone_customization_background_desktop.png',
            //             id: 'campaign_carbone_customization_background_desktop'
            //         },
            //         logo: {
            //             thumbnail: 'assets/img/smash-logo/png/icono-chip-full-white.png',
            //             sourceUrl: 'assets/img/smash-logo/png/icono-chip-full-white.png',
            //         }
            //     },
            //     promotions: [
            //         {
            //             language: 'de',
            //             teaserDisabled: true,
            //             text: 'Die Digitaltechnik ist für 4 % der weltweiten Treibhausgasemissionen verantwortlich. Der Versand Ihrer Dateien per Smash ist also besser für den Planeten.',
            //             link: 'https://fromsmash.com/de/smashs-carbon-footprint',
            //             target: 'Internal',
            //             status: 'Enabled',
            //             button: 'LearnMore',
            //             id: 'CARBON_PROMOTION_DESKTOP_INTERNAL',
            //             title: 'Carbone',
            //             medias: [
            //                 {
            //                     sourceUrl: 'assets/campaigns/smash/carbone/promotion/background_desktop_carbone_de.png',
            //                     type: 'Image'
            //                 },
            //             ]
            //         },
            //         {
            //             language: 'de',
            //             teaserDisabled: true,
            //             text: 'Die Digitaltechnik ist für 4 % der weltweiten Treibhausgasemissionen verantwortlich. Der Versand Ihrer Dateien per Smash ist also besser für den Planeten.',
            //             link: 'https://fromsmash.com/de/smashs-carbon-footprint',
            //             target: 'External',
            //             status: 'Enabled',
            //             button: 'LearnMore',
            //             id: 'CARBON_PROMOTION_DESKTOP_INTERNAL',
            //             title: 'Carbone',
            //             medias: [
            //                 {
            //                     sourceUrl: 'assets/campaigns/smash/carbone/promotion/background_desktop_carbone_de.png',
            //                     type: 'Image'
            //                 },
            //             ]
            //         }
            //     ]
            // },
            // {
            //     name: 'Carbone',
            //     language: 'IT',
            //     target: 'Uploader',
            //     customization: {
            //         background: {
            //             type: 'Image',
            //             sourceUrl: 'assets/campaigns/smash/carbone/customization/campaign_carbone_customization_background_desktop.png',
            //             id: 'campaign_carbone_customization_background_desktop'
            //         },
            //         logo: {
            //             thumbnail: 'assets/img/smash-logo/png/icono-chip-full-white.png',
            //             sourceUrl: 'assets/img/smash-logo/png/icono-chip-full-white.png',
            //         }
            //     },
            //     promotions: [
            //         {
            //             language: 'it',
            //             teaserDisabled: true,
            //             text: 'La tecnologia digitale è responsabile del 4% delle emissioni globali di gas serra. Quindi, inviare i vostri file con Smash è meglio per il pianeta.',
            //             link: 'https://fromsmash.com/it/smashs-carbon-footprint',
            //             target: 'Internal',
            //             status: 'Enabled',
            //             button: 'LearnMore',
            //             id: 'CARBON_PROMOTION_DESKTOP_INTERNAL',
            //             title: 'Carbone',
            //             medias: [
            //                 {
            //                     sourceUrl: 'assets/campaigns/smash/carbone/promotion/background_desktop_carbone_it.png',
            //                     type: 'Image'
            //                 },
            //             ]
            //         },
            //         {
            //             language: 'it',
            //             teaserDisabled: true,
            //             text: 'La tecnologia digitale è responsabile del 4% delle emissioni globali di gas serra. Quindi, inviare i vostri file con Smash è meglio per il pianeta.',
            //             link: 'https://fromsmash.com/it/smashs-carbon-footprint',
            //             target: 'External',
            //             status: 'Enabled',
            //             button: 'LearnMore',
            //             id: 'CARBON_PROMOTION_DESKTOP_INTERNAL',
            //             title: 'Carbone',
            //             medias: [
            //                 {
            //                     sourceUrl: 'assets/campaigns/smash/carbone/promotion/background_desktop_carbone_it.png',
            //                     type: 'Image'
            //                 },
            //             ]
            //         }
            //     ]
            // },
            // {
            //     name: 'Carbone',
            //     language: 'PT',
            //     target: 'Uploader',
            //     customization: {
            //         background: {
            //             type: 'Image',
            //             sourceUrl: 'assets/campaigns/smash/carbone/customization/campaign_carbone_customization_background_desktop.png',
            //             id: 'campaign_carbone_customization_background_desktop'
            //         },
            //         logo: {
            //             thumbnail: 'assets/img/smash-logo/png/icono-chip-full-white.png',
            //             sourceUrl: 'assets/img/smash-logo/png/icono-chip-full-white.png',
            //         }
            //     },
            //     promotions: [
            //         {
            //             language: 'pt',
            //             teaserDisabled: true,
            //             text: 'A tecnologia digital é responsável por 4% das emissões globais de gases com efeito de estufa. Por isso, enviar os seus ficheiros por Smash é melhor para o planeta.',
            //             link: 'https://fromsmash.com/pt/smashs-carbon-footprint',
            //             target: 'Internal',
            //             status: 'Enabled',
            //             button: 'LearnMore',
            //             id: 'CARBON_PROMOTION_DESKTOP_INTERNAL',
            //             title: 'Carbone',
            //             medias: [
            //                 {
            //                     sourceUrl: 'assets/campaigns/smash/carbone/promotion/background_desktop_carbone_pt.png',
            //                     type: 'Image'
            //                 },
            //             ]
            //         },
            //         {
            //             language: 'pt',
            //             teaserDisabled: true,
            //             text: 'A tecnologia digital é responsável por 4% das emissões globais de gases com efeito de estufa. Por isso, enviar os seus ficheiros por Smash é melhor para o planeta.',
            //             link: 'https://fromsmash.com/pt/smashs-carbon-footprint',
            //             target: 'External',
            //             status: 'Enabled',
            //             button: 'LearnMore',
            //             id: 'CARBON_PROMOTION_DESKTOP_INTERNAL',
            //             title: 'Carbone',
            //             medias: [
            //                 {
            //                     sourceUrl: 'assets/campaigns/smash/carbone/promotion/background_desktop_carbone_pt.png',
            //                     type: 'Image'
            //                 },
            //             ]
            //         }
            //     ]
            // },
            // {
            //     name: 'Carbone',
            //     language: 'DEFAULT',
            //     target: 'Uploader',
            //     customization: {
            //         background: {
            //             type: 'Image',
            //             sourceUrl: 'assets/campaigns/smash/carbone/customization/campaign_carbone_customization_background_desktop.png',
            //             id: 'campaign_carbone_customization_background_desktop'
            //         },
            //         logo: {
            //             thumbnail: 'assets/img/smash-logo/png/icono-chip-full-white.png',
            //             sourceUrl: 'assets/img/smash-logo/png/icono-chip-full-white.png',
            //         }
            //     },
            //     promotions: [
            //         {
            //             language: 'en',
            //             teaserDisabled: true,
            //             text: 'Digital technology accounts for 4% of global greenhouse gas emissions. So, sending your files by Smash is better for the planet.',
            //             link: 'https://fromsmash.com/smashs-carbon-footprint',
            //             target: 'Internal',
            //             status: 'Enabled',
            //             button: 'LearnMore',
            //             id: 'CARBON_PROMOTION_DESKTOP_INTERNAL',
            //             title: 'Carbone',
            //             medias: [
            //                 {
            //                     sourceUrl: 'assets/campaigns/smash/carbone/promotion/background_desktop_carbone_en.png',
            //                     type: 'Image'
            //                 },
            //             ]
            //         },
            //         {
            //             language: 'en',
            //             teaserDisabled: true,
            //             text: 'Digital technology accounts for 4% of global greenhouse gas emissions. So, sending your files by Smash is better for the planet.',
            //             link: 'https://fromsmash.com/smashs-carbon-footprint',
            //             target: 'External',
            //             status: 'Enabled',
            //             button: 'LearnMore',
            //             id: 'CARBON_PROMOTION_DESKTOP_INTERNAL',
            //             title: 'Carbone',
            //             medias: [
            //                 {
            //                     sourceUrl: 'assets/campaigns/smash/carbone/promotion/background_desktop_carbone_en.png',
            //                     type: 'Image'
            //                 },
            //             ]
            //         }
            //     ]
            // },
            // SMASH - Offre spéciales (only uploader)
            {
                name: 'Offre spéciale 1',
                language: 'DEFAULT',
                target: 'All',
                customization: {
                    background: {
                        type: 'Image',
                        sourceUrl: 'assets/campaigns/smash/crazydays/Smash_Teasing_01.png',
                        id: 'campaign_offre_customization_background_desktop'
                    },
                    logo: {
                        thumbnail: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                        sourceUrl: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                    }
                },
                promotions: [
                    {
                        language: 'fr',
                        teaserDisabled: true,
                        text: 'Découvrez dès maintenant l\'offre spéciale. Offre à durée limitée.',
                        link: 'https://fromsmash.com/fr/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/FR.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'en',
                        teaserDisabled: true,
                        text: 'Discover the limited-time offer now.',
                        link: 'https://fromsmash.com/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/EN.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'es',
                        teaserDisabled: true,
                        text: 'Descubra ahora la oferta por tiempo limitado.',
                        link: 'https://fromsmash.com/es/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/ES.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'de',
                        teaserDisabled: true,
                        text: 'Entdecken Sie jetzt das zeitlich begrenzte Angebot.',
                        link: 'https://fromsmash.com/de/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/DE.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'it',
                        teaserDisabled: true,
                        text: 'Scoprite subito l\'offerta a tempo limitato.',
                        link: 'https://fromsmash.com/it/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/IT.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'pt',
                        teaserDisabled: true,
                        text: 'Descubra agora a oferta de tempo limitado.',
                        link: 'https://fromsmash.com/pt/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/PT.png',
                                type: 'Image'
                            },
                        ]
                    }
                ]
            },
            {
                name: 'Offre spéciale 2',
                language: 'DEFAULT',
                target: 'All',
                customization: {
                    background: {
                        type: 'Image',
                        sourceUrl: 'assets/campaigns/smash/crazydays/Smash_Teasing_02.png',
                        id: 'campaign_offre_customization_background_desktop'
                    },
                    logo: {
                        thumbnail: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                        sourceUrl: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                    }
                },
                promotions: [
                    {
                        language: 'fr',
                        teaserDisabled: true,
                        text: 'Découvrez dès maintenant l\'offre spéciale. Offre à durée limitée.',
                        link: 'https://fromsmash.com/fr/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/FR.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'en',
                        teaserDisabled: true,
                        text: 'Discover the limited-time offer now.',
                        link: 'https://fromsmash.com/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/EN.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'es',
                        teaserDisabled: true,
                        text: 'Descubra ahora la oferta por tiempo limitado.',
                        link: 'https://fromsmash.com/es/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/ES.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'de',
                        teaserDisabled: true,
                        text: 'Entdecken Sie jetzt das zeitlich begrenzte Angebot.',
                        link: 'https://fromsmash.com/de/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/DE.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'it',
                        teaserDisabled: true,
                        text: 'Scoprite subito l\'offerta a tempo limitato.',
                        link: 'https://fromsmash.com/it/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/IT.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'pt',
                        teaserDisabled: true,
                        text: 'Descubra agora a oferta de tempo limitado.',
                        link: 'https://fromsmash.com/pt/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/PT.png',
                                type: 'Image'
                            },
                        ]
                    }
                ]
            },
            {
                name: 'Offre spéciale 3',
                language: 'DEFAULT',
                target: 'All',
                customization: {
                    background: {
                        type: 'Image',
                        sourceUrl: 'assets/campaigns/smash/crazydays/Smash_Teasing_03.png',
                        id: 'campaign_offre_customization_background_desktop'
                    },
                    logo: {
                        thumbnail: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                        sourceUrl: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                    }
                },
                promotions: [
                    {
                        language: 'fr',
                        teaserDisabled: true,
                        text: 'Découvrez dès maintenant l\'offre spéciale. Offre à durée limitée.',
                        link: 'https://fromsmash.com/fr/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/FR.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'en',
                        teaserDisabled: true,
                        text: 'Discover the limited-time offer now.',
                        link: 'https://fromsmash.com/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/EN.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'es',
                        teaserDisabled: true,
                        text: 'Descubra ahora la oferta por tiempo limitado.',
                        link: 'https://fromsmash.com/es/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/ES.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'de',
                        teaserDisabled: true,
                        text: 'Entdecken Sie jetzt das zeitlich begrenzte Angebot.',
                        link: 'https://fromsmash.com/de/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/DE.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'it',
                        teaserDisabled: true,
                        text: 'Scoprite subito l\'offerta a tempo limitato.',
                        link: 'https://fromsmash.com/it/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/IT.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'pt',
                        teaserDisabled: true,
                        text: 'Descubra agora a oferta de tempo limitado.',
                        link: 'https://fromsmash.com/pt/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/PT.png',
                                type: 'Image'
                            },
                        ]
                    }
                ]
            },
            {
                name: 'Offre spéciale 4',
                language: 'DEFAULT',
                target: 'All',
                customization: {
                    background: {
                        type: 'Image',
                        sourceUrl: 'assets/campaigns/smash/crazydays/Smash_Teasing_04.png',
                        id: 'campaign_offre_customization_background_desktop'
                    },
                    logo: {
                        thumbnail: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                        sourceUrl: 'assets/img/smash-logo/png/icono-chip-full-white.png',
                    }
                },
                promotions: [
                    {
                        language: 'fr',
                        teaserDisabled: true,
                        text: 'Découvrez dès maintenant l\'offre spéciale. Offre à durée limitée.',
                        link: 'https://fromsmash.com/fr/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/FR.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'en',
                        teaserDisabled: true,
                        text: 'Discover the limited-time offer now.',
                        link: 'https://fromsmash.com/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/EN.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'es',
                        teaserDisabled: true,
                        text: 'Descubra ahora la oferta por tiempo limitado.',
                        link: 'https://fromsmash.com/es/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/ES.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'de',
                        teaserDisabled: true,
                        text: 'Entdecken Sie jetzt das zeitlich begrenzte Angebot.',
                        link: 'https://fromsmash.com/de/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/DE.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'it',
                        teaserDisabled: true,
                        text: 'Scoprite subito l\'offerta a tempo limitato.',
                        link: 'https://fromsmash.com/it/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/IT.png',
                                type: 'Image'
                            },
                        ]
                    },
                    {
                        language: 'pt',
                        teaserDisabled: true,
                        text: 'Descubra agora a oferta de tempo limitado.',
                        link: 'https://fromsmash.com/pt/special-deal?utm_source=smash&utm_medium=promo&utm_content=crazy-days',
                        target: 'Internal',
                        status: 'Enabled',
                        button: 'Discover',
                        id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
                        title: 'Offre spéciale',
                        medias: [
                            {
                                sourceUrl: 'assets/campaigns/smash/crazydays/PT.png',
                                type: 'Image'
                            },
                        ]
                    }
                ]
            },
            // {
            //     name: 'Offre spéciale',
            //     language: 'ES',
            //     target: 'Uploader',
            //     customization: {
            //         background: {
            //             type: 'Image',
            //             sourceUrl: 'assets/campaigns/smash/offer/customization/2024.jpg',
            //             id: 'campaign_offre_customization_background_desktop'
            //         },
            //         logo: {
            //             thumbnail: 'assets/img/smash-logo/png/icono-chip-full-white.png',
            //             sourceUrl: 'assets/img/smash-logo/png/icono-chip-full-white.png',
            //         }
            //     },
            //     promotions: [
            //         {
            //             language: 'es',
            //             teaserDisabled: true,
            //             text: 'Descubra ahora la oferta por tiempo limitado.',
            //             link: 'https://fromsmash.com/es/special-deal?utm_source=smash&utm_medium=promo&utm_content=happy-new-smash',
            //             target: 'Internal',
            //             status: 'Enabled',
            //             button: 'Discover',
            //             id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
            //             title: 'Offre spéciale',
            //             medias: [
            //                 {
            //                     sourceUrl: 'assets/campaigns/smash/offer/promotion/2024_es.png',
            //                     type: 'Image'
            //                 },
            //             ]
            //         }
            //     ]
            // },
            // {
            //     name: 'Offre spéciale',
            //     language: 'EN',
            //     target: 'Uploader',
            //     customization: {
            //         background: {
            //             type: 'Image',
            //             sourceUrl: 'assets/campaigns/smash/offer/customization/2024.jpg',
            //             id: 'campaign_offre_customization_background_desktop'
            //         },
            //         logo: {
            //             thumbnail: 'assets/img/smash-logo/png/icono-chip-full-white.png',
            //             sourceUrl: 'assets/img/smash-logo/png/icono-chip-full-white.png',
            //         }
            //     },
            //     promotions: [
            //         {
            //             language: 'en',
            //             teaserDisabled: true,
            //             text: 'Discover the limited-time offer now.',
            //             link: 'https://fromsmash.com/special-deal?utm_source=smash&utm_medium=promo&utm_content=happy-new-smash',
            //             target: 'Internal',
            //             status: 'Enabled',
            //             button: 'Discover',
            //             id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
            //             title: 'Offre spéciale',
            //             medias: [
            //                 {
            //                     sourceUrl: 'assets/campaigns/smash/offer/promotion/2024_en.png',
            //                     type: 'Image'
            //                 },
            //             ]
            //         }
            //     ]
            // },
            // {
            //     name: 'Offre spéciale',
            //     language: 'DE',
            //     target: 'Uploader',
            //     customization: {
            //         background: {
            //             type: 'Image',
            //             sourceUrl: 'assets/campaigns/smash/offer/customization/2024.jpg',
            //             id: 'campaign_offre_customization_background_desktop'
            //         },
            //         logo: {
            //             thumbnail: 'assets/img/smash-logo/png/icono-chip-full-white.png',
            //             sourceUrl: 'assets/img/smash-logo/png/icono-chip-full-white.png',
            //         }
            //     },
            //     promotions: [
            //         {
            //             language: 'de',
            //             teaserDisabled: true,
            //             text: 'Entdecken Sie jetzt das zeitlich begrenzte Angebot.',
            //             link: 'https://fromsmash.com/de/special-deal?utm_source=smash&utm_medium=promo&utm_content=happy-new-smash',
            //             target: 'Internal',
            //             status: 'Enabled',
            //             button: 'Discover',
            //             id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
            //             title: 'Offre spéciale',
            //             medias: [
            //                 {
            //                     sourceUrl: 'assets/campaigns/smash/offer/promotion/2024_de.png',
            //                     type: 'Image'
            //                 },
            //             ]
            //         }
            //     ]
            // },
            // {
            //     name: 'Offre spéciale',
            //     language: 'IT',
            //     target: 'Uploader',
            //     customization: {
            //         background: {
            //             type: 'Image',
            //             sourceUrl: 'assets/campaigns/smash/offer/customization/2024.jpg',
            //             id: 'campaign_offre_customization_background_desktop'
            //         },
            //         logo: {
            //             thumbnail: 'assets/img/smash-logo/png/icono-chip-full-white.png',
            //             sourceUrl: 'assets/img/smash-logo/png/icono-chip-full-white.png',
            //         }
            //     },
            //     promotions: [
            //         {
            //             language: 'it',
            //             teaserDisabled: true,
            //             text: 'Scoprite subito l\'offerta a tempo limitato.',
            //             link: 'https://fromsmash.com/it/special-deal?utm_source=smash&utm_medium=promo&utm_content=happy-new-smash',
            //             target: 'Internal',
            //             status: 'Enabled',
            //             button: 'Discover',
            //             id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
            //             title: 'Offre spéciale',
            //             medias: [
            //                 {
            //                     sourceUrl: 'assets/campaigns/smash/offer/promotion/2024_it.png',
            //                     type: 'Image'
            //                 },
            //             ]
            //         }
            //     ]
            // },
            // {
            //     name: 'Offre spéciale',
            //     language: 'PT',
            //     target: 'Uploader',
            //     customization: {
            //         background: {
            //             type: 'Image',
            //             sourceUrl: 'assets/campaigns/smash/offer/customization/2024.jpg',
            //             id: 'campaign_offre_customization_background_desktop'
            //         },
            //         logo: {
            //             thumbnail: 'assets/img/smash-logo/png/icono-chip-full-white.png',
            //             sourceUrl: 'assets/img/smash-logo/png/icono-chip-full-white.png',
            //         }
            //     },
            //     promotions: [
            //         {
            //             language: 'pt',
            //             teaserDisabled: true,
            //             text: 'Descubra agora a oferta de tempo limitado.',
            //             link: 'https://fromsmash.com/pt/special-deal?utm_source=smash&utm_medium=promo&utm_content=happy-new-smash',
            //             target: 'Internal',
            //             status: 'Enabled',
            //             button: 'Discover',
            //             id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
            //             title: 'Offre spéciale',
            //             medias: [
            //                 {
            //                     sourceUrl: 'assets/campaigns/smash/offer/promotion/2024_pt.png',
            //                     type: 'Image'
            //                 },
            //             ]
            //         }
            //     ]
            // },
            // {
            //     name: 'Offre spéciale',
            //     language: 'DEFAULT',
            //     target: 'Uploader',
            //     customization: {
            //         background: {
            //             type: 'Image',
            //             sourceUrl: 'assets/campaigns/smash/offer/customization/2024.jpg',
            //             id: 'campaign_offre_customization_background_desktop'
            //         },
            //         logo: {
            //             thumbnail: 'assets/img/smash-logo/png/icono-chip-full-white.png',
            //             sourceUrl: 'assets/img/smash-logo/png/icono-chip-full-white.png',
            //         }
            //     },
            //     promotions: [
            //         {
            //             language: 'en',
            //             teaserDisabled: true,
            //             text: 'Discover the limited-time offer now.',
            //             link: 'https://fromsmash.com/special-deal?utm_source=smash&utm_medium=promo&utm_content=happy-new-smash',
            //             target: 'Internal',
            //             status: 'Enabled',
            //             button: 'Discover',
            //             id: 'OFFRE_PROMOTION_DESKTOP_INTERNAL',
            //             title: 'Offre spéciale',
            //             medias: [
            //                 {
            //                     sourceUrl: 'assets/campaigns/smash/offer/promotion/2024_en.png',
            //                     type: 'Image'
            //                 },
            //             ]
            //         }
            //     ]
            // },
            // SMASH - Smash for free (only viewer)
            // {
            //     name: 'Smash for free',
            //     language: 'EN',
            //     target: 'Viewer',
            //     customization: {
            //         logo: {
            //             thumbnail: 'assets/img/smash-logo/png/icono-chip-full-white.png',
            //             sourceUrl: 'assets/img/smash-logo/png/icono-chip-full-white.png',
            //         }
            //     },
            //     promotions: [
            //         {
            //             title: 'Send your files for free',
            //             teaser: '- Message from Smash -',
            //             text: 'You too, use Smash’s site and apps to send your files. It\'s free!',
            //             button: 'LearnMore',
            //             link: 'https://en.fromsmash.com',
            //             language: 'en',
            //             status: 'Enabled',
            //             target: 'External',
            //             medias: [
            //                 {
            //                     sourceUrl: 'assets/campaigns/smash/free/promotion/big_files.jpg',
            //                     type: 'Image'
            //                 }
            //             ]
            //         },
            //     ]
            // },
            // {
            //     name: 'Smash for free',
            //     language: 'IT',
            //     target: 'Viewer',
            //     customization: {
            //         logo: {
            //             thumbnail: 'assets/img/smash-logo/png/icono-chip-full-white.png',
            //             sourceUrl: 'assets/img/smash-logo/png/icono-chip-full-white.png',
            //         }
            //     },
            //     promotions: [
            //         {
            //             title: 'Send your files for free',
            //             teaser: '- Message from Smash -',
            //             text: 'You too, use Smash’s site and apps to send your files. It\'s free!',
            //             button: 'LearnMore',
            //             link: 'https://en.fromsmash.com',
            //             language: 'en',
            //             status: 'Enabled',
            //             target: 'External',
            //             medias: [
            //                 {
            //                     sourceUrl: 'assets/campaigns/smash/free/promotion/big_files.jpg',
            //                     type: 'Image'
            //                 }
            //             ]
            //         },
            //     ]
            // },
            // {
            //     name: 'Smash for free',
            //     language: 'ES',
            //     target: 'Viewer',
            //     customization: {
            //         logo: {
            //             thumbnail: 'assets/img/smash-logo/png/icono-chip-full-white.png',
            //             sourceUrl: 'assets/img/smash-logo/png/icono-chip-full-white.png',
            //         }
            //     },
            //     promotions: [
            //         {
            //             title: 'Send your files for free',
            //             teaser: '- Mensaje del equipo Smash -',
            //             text: 'Tú también, usa la web y las aplicaciones de Smash para enviar archivos. ¡Es gratis!',
            //             button: 'LearnMore',
            //             link: 'https://es.fromsmash.com/',
            //             language: 'es',
            //             status: 'Enabled',
            //             target: 'External',
            //             medias: [
            //                 {
            //                     sourceUrl: 'assets/campaigns/smash/free/promotion/big_files_ES.png',
            //                     type: 'Image'
            //                 }
            //             ]
            //         },
            //     ]
            // },
            // {
            //     name: 'Smash for free',
            //     language: 'PT',
            //     target: 'Viewer',
            //     customization: {
            //         logo: {
            //             thumbnail: 'assets/img/smash-logo/png/icono-chip-full-white.png',
            //             sourceUrl: 'assets/img/smash-logo/png/icono-chip-full-white.png',
            //         }
            //     },
            //     promotions: [
            //         {
            //             title: 'Send your files for free',
            //             teaser: '- Message from Smash -',
            //             text: 'You too, use Smash’s site and apps to send your files. It\'s free!',
            //             button: 'LearnMore',
            //             link: 'https://en.fromsmash.com',
            //             language: 'pt',
            //             status: 'Enabled',
            //             target: 'External',
            //             medias: [
            //                 {
            //                     sourceUrl: 'assets/campaigns/smash/free/promotion/big_files.jpg',
            //                     type: 'Image'
            //                 }
            //             ]
            //         },
            //     ]
            // },
            // {
            //     name: 'Smash for free',
            //     language: 'DE',
            //     target: 'Viewer',
            //     customization: {
            //         logo: {
            //             thumbnail: 'assets/img/smash-logo/png/icono-chip-full-white.png',
            //             sourceUrl: 'assets/img/smash-logo/png/icono-chip-full-white.png',
            //         }
            //     },
            //     promotions: [
            //         {
            //             title: 'Send your files for free',
            //             teaser: '- Message from Smash -',
            //             text: 'You too, use Smash’s site and apps to send your files. It\'s free!',
            //             button: 'LearnMore',
            //             link: 'https://en.fromsmash.com',
            //             language: 'de',
            //             status: 'Enabled',
            //             target: 'External',
            //             medias: [
            //                 {
            //                     sourceUrl: 'assets/campaigns/smash/free/promotion/big_files.jpg',
            //                     type: 'Image'
            //                 }
            //             ]
            //         },
            //     ]
            // },
            // {
            //     name: 'Smash for free',
            //     language: 'DEFAULT',
            //     target: 'Viewer',
            //     customization: {
            //         logo: {
            //             thumbnail: 'assets/img/smash-logo/png/icono-chip-full-white.png',
            //             sourceUrl: 'assets/img/smash-logo/png/icono-chip-full-white.png',
            //         }
            //     },
            //     promotions: [
            //         {
            //             title: 'Send your files for free',
            //             teaser: '- Message from Smash -',
            //             text: 'You too, use Smash’s site and apps to send your files. It\'s free!',
            //             button: 'LearnMore',
            //             link: 'https://en.fromsmash.com',
            //             language: 'en',
            //             status: 'Enabled',
            //             target: 'External',
            //             medias: [
            //                 {
            //                     sourceUrl: 'assets/campaigns/smash/free/promotion/big_files.jpg',
            //                     type: 'Image'
            //                 }
            //             ]
            //         },
            //     ]
            // },
        ],
    };
    // END TO REMOVE

    public static errorTypes = {
        Password: 'PasswordDoesNotMatchError',
        Email: 'InvalidEmailError',
        AccessorUsageExceeded: 'AccessorUsageExceededError',
        OwnerUsageExceeded: 'OwnerUsageExceededError'

    };

    public static redirection = {
        main: 'fromsmash',
        unsupported: '/unsupported',
        serviceUnavailable: '/service-unavailable'
    };

    public static serviceErrors = {
        discovery: 'DISCOVERY_ERROR',
        domain: 'DOMAIN_ERROR'
    };
}
